(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[553],{

/***/ 4745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87114);
/* harmony import */ var components_common_BSpinnerInline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22773);
/* harmony import */ var enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7794);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56787);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32466);







var PriceWidgetCTAButton = function(param) {
    var onClick = param.onClick, supportedDemandTypes = param.supportedDemandTypes, pricing = param.pricing, className = param.className, _fluid = param.fluid, fluid = _fluid === void 0 ? false : _fluid, isCalculateAmountRequestSent = param.isCalculateAmountRequestSent, isCalcutePricingRequestOngoing = param.isCalcutePricingRequestOngoing, _isDemandRequestOngoing = param.isDemandRequestOngoing, isDemandRequestOngoing = _isDemandRequestOngoing === void 0 ? false : _isDemandRequestOngoing;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("vehicle").t;
    var hasPrice = pricing === null || pricing === void 0 ? void 0 : pricing.totalAmount;
    var checkonlyImmediatelyReservable = function() {
        var isImmediateReservation = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.IMMEDIATE_RESERVATION */ .g.IMMEDIATE_RESERVATION);
        return isImmediateReservation && (hasPrice || !isCalculateAmountRequestSent);
    };
    var checkIsReservationRequestable = function() {
        var isReservationRequest = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.RESERVATION */ .g.RESERVATION);
        return isReservationRequest && (hasPrice || !isCalculateAmountRequestSent);
    };
    var checkIsRequestPrice = function() {
        var isImmediateReservation = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.IMMEDIATE_RESERVATION */ .g.IMMEDIATE_RESERVATION);
        var isReservationRequest = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.RESERVATION */ .g.RESERVATION);
        var isPrice = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.PRICE */ .g.PRICE);
        var isImmediateReservationWithoutPrice = isImmediateReservation && !hasPrice;
        var isReservationRequestWithoutPrice = isReservationRequest && !hasPrice;
        return isPrice || isImmediateReservationWithoutPrice || isReservationRequestWithoutPrice;
    };
    var buttonLabel = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        if (checkonlyImmediatelyReservable()) {
            return "priceWidget.actions.immediatelyReserve";
        }
        if (checkIsReservationRequestable()) {
            return "priceWidget.actions.reservationRequest";
        }
        if (checkIsRequestPrice()) {
            return "priceWidget.actions.requestPrice";
        }
        var isAvailability = supportedDemandTypes.includes(enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_4__/* .SupportedDemandType.AVAILABILITY */ .g.AVAILABILITY);
        if (isAvailability && (hasPrice || !isCalculateAmountRequestSent)) {
            return "priceWidget.actions.checkAvailibility";
        } else {
            return "priceWidget.actions.requestPrice";
        }
    }, [
        pricing,
        supportedDemandTypes
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("!py-3", className),
        fluid: fluid,
        type: "submit",
        onClick: onClick,
        disabled: isCalcutePricingRequestOngoing || isDemandRequestOngoing,
        children: isCalcutePricingRequestOngoing || isDemandRequestOngoing ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BSpinnerInline__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 24,
            className: "mx-auto"
        }) : t(buttonLabel)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceWidgetCTAButton);


/***/ }),

/***/ 33961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PriceWidget_PriceWidgetDailyWeeklyForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(80072);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59354);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36840);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(36333);
// EXTERNAL MODULE: ./src/hooks/useTranslatedNavigation.ts
var useTranslatedNavigation = __webpack_require__(58776);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js
var useTranslation = __webpack_require__(56787);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(90935);
// EXTERNAL MODULE: ./src/services/DateService.ts
var DateService = __webpack_require__(49163);
// EXTERNAL MODULE: ./src/services/DemandService.ts + 1 modules
var DemandService = __webpack_require__(57441);
// EXTERNAL MODULE: ./src/validation/demand.validation.ts
var demand_validation = __webpack_require__(90119);
// EXTERNAL MODULE: ./src/hooks/useQueryParams.ts
var useQueryParams = __webpack_require__(78285);
// EXTERNAL MODULE: ./src/hooks/useAuthCheck.ts
var useAuthCheck = __webpack_require__(63932);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetCTAButton.tsx
var PriceWidgetCTAButton = __webpack_require__(4745);
// EXTERNAL MODULE: ./node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(78480);
// EXTERNAL MODULE: ./src/hooks/priceWidget/useCheckPricingExists.ts
var useCheckPricingExists = __webpack_require__(188);
// EXTERNAL MODULE: ./src/enums/supportedRentalTypes.ts
var supportedRentalTypes = __webpack_require__(87644);
// EXTERNAL MODULE: ./src/utils/getDWDuration.ts
var getDWDuration = __webpack_require__(8014);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetCalculateDWDuration.ts



function usePriceWidgetCalculateDWDuration(rentalInfo) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var calculateDWDemandVariant = function(state) {
        if (rentalInfo.supportedRentalTypes.length === 1) {
            return rentalInfo.supportedRentalTypes[0];
        }
        if (DateService/* dateService.getDayDuration */.o.getDayDuration(state.startDate, state.endDate) === 0 && state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY) {
            return supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY;
        }
        var isDurationWeekly = DateService/* dateService.getDayDuration */.o.getDayDuration(state.startDate, state.endDate) % 7 === 0;
        var isDatesAligned = DateService/* dateService.getDayIndexAlignedWithDayjs */.o.getDayIndexAlignedWithDayjs(rentalInfo.checkInDay) === state.startDate.getDay() && DateService/* dateService.getDayIndexAlignedWithDayjs */.o.getDayIndexAlignedWithDayjs(rentalInfo.checkOutDay) === state.endDate.getDay();
        return isDurationWeekly && isDatesAligned ? supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY : supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY;
    };
    var getDemandDWDuration = function(state) {
        return (0,getDWDuration/* getDWDuration */.f)(state.startDate, state.endDate, state.demandVariant);
    };
    var formatDatesToCorrectHours = function(state) {
        var startDate = state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY ? dayjs(state.startDate).hour(10).toDate() : dayjs(state.startDate).hour(rentalInfo.checkInHour).toDate();
        var endDate = state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY ? dayjs(state.endDate).hour(18).toDate() : dayjs(state.endDate).hour(rentalInfo.checkOutHour).toDate();
        return {
            startDate: startDate,
            endDate: endDate
        };
    };
    return {
        calculateDWDemandVariant: calculateDWDemandVariant,
        getDemandDWDuration: getDemandDWDuration,
        formatDatesToCorrectHours: formatDatesToCorrectHours
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWCalculateAmounts.ts










function usePriceWidgetDWCalculateAmounts(vehicleId, supportedServices, setPricing, supportedDemandTypes, validateForm, setIsCalculateAmountRequestSent, setIsCalcutePricingRequestOngoing, pricing, rentalInfo) {
    var checkPricingExists = (0,useCheckPricingExists/* useCheckPricingExists */.D)(supportedDemandTypes).checkPricingExists;
    var ref = usePriceWidgetCalculateDWDuration(rentalInfo), calculateDWDemandVariant = ref.calculateDWDemandVariant, getDemandDWDuration = ref.getDemandDWDuration, formatDatesToCorrectHours = ref.formatDatesToCorrectHours;
    var handleCalculateAmounts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(state) {
            var localState, isValid, duration, payload, pricings;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkPricingExists()) return [
                            2,
                            false
                        ];
                        setIsCalcutePricingRequestOngoing(false);
                        localState = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            numberOfPeople: +state.numberOfPeople === 0 ? "1" : "".concat(state.numberOfPeople),
                            demandVariant: calculateDWDemandVariant(state)
                        }), formatDatesToCorrectHours(state));
                        return [
                            4,
                            validateForm(localState, false)
                        ];
                    case 1:
                        isValid = _state.sent();
                        if (!isValid) return [
                            2,
                            false
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]);
                        !pricing && setIsCalcutePricingRequestOngoing(true);
                        duration = getDemandDWDuration(localState);
                        payload = DemandService/* demandService.formatVehicleBasedDWDemandStateToDemand */.l.formatVehicleBasedDWDemandStateToDemand(localState, vehicleId, (0,_to_consumable_array/* default */.Z)(supportedServices), undefined, duration);
                        return [
                            4,
                            DemandService/* demandService.calculatePricing */.l.calculatePricing((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "API"
                            }))
                        ];
                    case 3:
                        pricings = _state.sent();
                        setPricing((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pricings), {
                            duration: duration
                        }));
                        setIsCalculateAmountRequestSent(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsCalcutePricingRequestOngoing(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCalculateAmounts(state) {
            return _ref.apply(this, arguments);
        };
    }();
    var debouncedHandleCalculateAmounts = (0,index_module/* useDebouncedCallback */.y1)(handleCalculateAmounts, 500);
    (0,react.useEffect)(function() {
        return function() {
            debouncedHandleCalculateAmounts.flush();
        };
    }, [
        debouncedHandleCalculateAmounts
    ]);
    return {
        handleCalculateAmounts: handleCalculateAmounts,
        debouncedHandleCalculateAmounts: debouncedHandleCalculateAmounts
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWPeopleLimits.ts


function usePriceWidgetDWPeopleLimits(state, dispatch, cruisingCapacity, overnightCapacity) {
    var MAX_PEOPLE = (0,react.useMemo)(function() {
        return state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY ? cruisingCapacity : overnightCapacity;
    }, [
        state,
        cruisingCapacity,
        overnightCapacity
    ]);
    var MIN_PEOPLE = (0,react.useMemo)(function() {
        return 1;
    }, []);
    (0,react.useEffect)(function() {
        if (+state.numberOfPeople > MAX_PEOPLE) {
            dispatch({
                type: "numberOfPeople",
                payload: "".concat(MAX_PEOPLE)
            });
        }
    }, [
        state.numberOfPeople,
        MAX_PEOPLE
    ]);
    return {
        MAX_PEOPLE: MAX_PEOPLE,
        MIN_PEOPLE: MIN_PEOPLE
    };
}

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Form/BStepperInput.tsx + 2 modules
var BStepperInput = __webpack_require__(32600);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./src/enums/locale.ts
var enums_locale = __webpack_require__(42111);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/tr/index.js + 5 modules
var tr = __webpack_require__(18903);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/en-US/index.js + 5 modules
var en_US = __webpack_require__(18798);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts
var useLocale = __webpack_require__(74021);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var dist = __webpack_require__(43047);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(71541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(32049);
// EXTERNAL MODULE: ./src/components/Form/BLabeledInput.tsx
var BLabeledInput = __webpack_require__(12323);
;// CONCATENATED MODULE: ./src/components/Form/BDateRangePicker.tsx









 // main style file



var BDateRangePicker = function(_param) {
    var ranges = _param.ranges, onChange = _param.onChange, rangeLabels = _param.rangeLabels, nonRangeLabel = _param.nonRangeLabel, labelClasses = _param.labelClasses, isRange = _param.isRange, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ranges",
        "onChange",
        "rangeLabels",
        "nonRangeLabel",
        "labelClasses",
        "isRange",
        "children"
    ]);
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var ref = (0,react.useState)(false), isDatePickerOpen = ref[0], setIsDatePickerOpen = ref[1];
    var toggleDatePicker = function() {
        setIsDatePickerOpen(function(d) {
            return !d;
        });
    };
    var _obj;
    var selectedLocale = (_obj = {}, (0,_define_property/* default */.Z)(_obj, enums_locale/* Locale.TR */.g.TR, tr/* default */.Z), (0,_define_property/* default */.Z)(_obj, enums_locale/* Locale.EN */.g.EN, en_US["default"]), _obj)[locale];
    var formatInputValue = function(date) {
        return date ? DateService/* dateService.getReadableDate */.o.getReadableDate(date) : "";
    };
    var dateRangePickerProps = (0,_object_spread/* default */.Z)({
        className: "overflow-hidden",
        color: "var(--clr-primary-500)",
        showDateDisplay: false,
        locale: selectedLocale,
        showMonthAndYearPickers: false,
        rangeColors: [
            "var(--clr-primary-500)"
        ],
        minDate: new Date()
    }, props);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid items-center gap-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BLabeledInput/* default */.Z, {
                    labelClassName: labelClasses,
                    label: isRange ? "".concat(rangeLabels.firstInput, " / ").concat(rangeLabels.lastInput) : nonRangeLabel,
                    value: isRange ? "".concat(formatInputValue(ranges === null || ranges === void 0 ? void 0 : ranges[0].startDate), " - ").concat(formatInputValue(ranges === null || ranges === void 0 ? void 0 : ranges[0].endDate)) : formatInputValue(ranges === null || ranges === void 0 ? void 0 : ranges[0].startDate),
                    readOnly: true,
                    className: "cursor-pointer text-center",
                    onClick: toggleDatePicker
                })
            }),
            isDatePickerOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed inset-0 z-50",
                        onClick: toggleDatePicker,
                        role: "presentation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-16 right-0 z-100 rounded-md border bg-white shadow-sm",
                        children: [
                            isRange ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* DateRangePicker */.Dw, (0,_object_spread/* default */.Z)({
                                ranges: ranges,
                                onChange: onChange
                            }, dateRangePickerProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Calendar */.f, (0,_object_spread/* default */.Z)({
                                date: ranges === null || ranges === void 0 ? void 0 : ranges[0].startDate,
                                onChange: function(date) {
                                    onChange === null || onChange === void 0 ? void 0 : onChange({
                                        state: {
                                            startDate: date,
                                            endDate: date
                                        }
                                    });
                                }
                            }, dateRangePickerProps)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var Form_BDateRangePicker = (BDateRangePicker);

// EXTERNAL MODULE: ./src/hooks/priceWidget/usePriceWidgetExtraSections.tsx
var usePriceWidgetExtraSections = __webpack_require__(21052);
// EXTERNAL MODULE: ./src/components/common/ModalWithActivator.tsx
var ModalWithActivator = __webpack_require__(30013);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtras.tsx
var PriceWidgetExtras = __webpack_require__(10855);
// EXTERNAL MODULE: ./src/components/common/BTabs.tsx
var BTabs = __webpack_require__(52940);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtrasEmptyView.tsx
var PriceWidgetExtrasEmptyView = __webpack_require__(85382);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWAvailableDays.ts


function usePriceWidgetDWAvailableDays(rentalInfo, state) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var disableDatesBeforeToday = function(date) {
        var today = dayjs().toDate();
        var todayCheckIn = dayjs(today).startOf("day").hour(rentalInfo.checkInHour).toDate();
        var isSameDate = DateService/* dateService.isSameDate */.o.isSameDate(todayCheckIn, date);
        return date.getTime() < today.getTime() || isSameDate && date.getTime() > todayCheckIn.getTime();
    };
    var getDisabledDays = function(date) {
        if (!rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY) && state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY) {
            // sunday offset
            return (date.getDay() - 1 + 7) % 7 !== rentalInfo.checkInDay || disableDatesBeforeToday(date);
        }
        return disableDatesBeforeToday(date);
    };
    return {
        getDisabledDays: getDisabledDays,
        disableDatesBeforeToday: disableDatesBeforeToday
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWReservedTimes.ts




var WEEK_DAY_COUNT = 7;
function usePriceWidgetDWReservedTimes(param) {
    var state = param.state, reservedTimes = param.reservedTimes, rentalInfo = param.rentalInfo;
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var mappedReservedTimes = (0,react.useMemo)(function() {
        var res = [];
        reservedTimes.forEach(function(reservedTime) {
            var _dateTimeRange = reservedTime.dateTimeRange, endTime = _dateTimeRange.endTime, startTime = _dateTimeRange.startTime;
            var tourStartTime = dayjs(startTime);
            var tourEndTime = dayjs(endTime);
            var dayDifference = DateService/* dateService.getDayDuration */.o.getDayDuration(tourStartTime.toDate(), tourEndTime.toDate());
            if (state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY) {
                (0,_to_consumable_array/* default */.Z)(Array(dayDifference + 1)).forEach(function(_, idx) {
                    res.push(tourStartTime.add(+idx, "day").toDate());
                });
            } else if (state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY) {
                if (dayDifference === 0) {
                    res.push(tourStartTime.toDate());
                } else {
                    (0,_to_consumable_array/* default */.Z)(Array(dayDifference)).forEach(function(_, idx) {
                        res.push(tourStartTime.add(+idx, "day").toDate());
                    });
                }
            } else if (state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY) {
                // convery to dayjs format for computing ease
                var weekStartDay = DateService/* dateService.getDayIndexAlignedWithDayjs */.o.getDayIndexAlignedWithDayjs(rentalInfo.checkInDay);
                (0,_to_consumable_array/* default */.Z)(Array(dayDifference)).forEach(function(_, idx) {
                    var currentDay = tourStartTime.add(+idx, "day");
                    if (+idx === 0) {
                        var eventStartWeekDay = tourStartTime.day();
                        var weekStartEventStartDiff = eventStartWeekDay - weekStartDay;
                        var remainingWeekDayCount = weekStartEventStartDiff;
                        if (remainingWeekDayCount < 0) {
                            remainingWeekDayCount = WEEK_DAY_COUNT + remainingWeekDayCount - 1;
                        }
                        (0,_to_consumable_array/* default */.Z)(Array(remainingWeekDayCount)).forEach(function(_, idx) {
                            res.push(currentDay.subtract(+idx + 1, "days").toDate());
                        });
                    }
                    if (+idx === dayDifference - 1) {
                        var eventEndWeekDay = tourEndTime.day();
                        var weekStartEventEndDiff = eventEndWeekDay - weekStartDay;
                        if (weekStartEventEndDiff > 0) {
                            var remainingWeekDayCount1 = WEEK_DAY_COUNT - weekStartEventEndDiff - 1;
                            (0,_to_consumable_array/* default */.Z)(Array(remainingWeekDayCount1)).forEach(function(_, idx) {
                                res.push(currentDay.add(+idx + 1, "days").toDate());
                            });
                        }
                    }
                    res.push(currentDay.toDate());
                });
            }
        });
        return res;
    }, [
        reservedTimes,
        dayjs,
        state.demandVariant
    ]);
    return {
        mappedReservedTimes: mappedReservedTimes
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWClosestAvailability.ts




function usePriceWidgetDWClosestAvailability(param) {
    var state = param.state, dispatch = param.dispatch, mappedReservedTimes = param.mappedReservedTimes, getDisabledDays = param.getDisabledDays, disableDatesBeforeToday = param.disableDatesBeforeToday;
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var isFirstLoop = (0,react.useRef)(true);
    var isDateAvailable = function(date) {
        if (getDisabledDays(date)) return false;
        return !mappedReservedTimes.some(function(d) {
            return DateService/* dateService.getFormattedDate */.o.getFormattedDate(d) === DateService/* dateService.getFormattedDate */.o.getFormattedDate(date);
        });
    };
    var isDateAvailableWeekly = function(date) {
        if (disableDatesBeforeToday(date)) return false;
        return !mappedReservedTimes.some(function(d) {
            return DateService/* dateService.getFormattedDate */.o.getFormattedDate(d) === DateService/* dateService.getFormattedDate */.o.getFormattedDate(date);
        });
    };
    var isDateRangeAvailable = function(param) {
        var startDate = param.startDate, endDate = param.endDate;
        var dayDifference = DateService/* dateService.getDayDuration */.o.getDayDuration(startDate, endDate);
        if (dayDifference < 0) return false;
        if (dayDifference === 0) return isDateAvailable(startDate);
        var dates = (0,_to_consumable_array/* default */.Z)(Array(dayDifference + 1)).map(function(_, idx) {
            return dayjs(startDate).add(+idx, "days").toDate();
        });
        for(var key in dates){
            var date = dates[key];
            if (state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY) {
                if (+key === 0 || +key === dates.length - 1) {
                    if (!isDateAvailable(date)) return false;
                } else {
                    if (!isDateAvailableWeekly(date)) return false;
                }
            } else {
                if (!isDateAvailable(date)) return false;
            }
        }
        return true;
    };
    var findFirstAvailableDate = function(startDate, endDate, demandVariant) {
        var currentDayOffset = 0;
        var maxDayLimit = 100;
        var startEndOffset = demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY ? 0 : demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY ? 1 : 7;
        var isEndDateAlignedWithOffset = DateService/* dateService.getDayDuration */.o.getDayDuration(startDate, endDate) % startEndOffset === 0;
        while(currentDayOffset < maxDayLimit){
            var currentStartDay = dayjs(startDate).add(currentDayOffset, "days").toDate();
            var currentEndDay = (isFirstLoop.current && isEndDateAlignedWithOffset ? dayjs(endDate) : dayjs(currentStartDay).add(startEndOffset, "days")).toDate();
            isFirstLoop.current = false;
            if (isDateRangeAvailable({
                startDate: currentStartDay,
                endDate: currentEndDay
            })) {
                return {
                    startDate: currentStartDay,
                    endDate: currentEndDay
                };
            }
            currentDayOffset++;
        }
    };
    (0,react.useEffect)(function() {
        if (state.startDate && state.endDate) {
            var findedFirstAvailableDate = findFirstAvailableDate(state.startDate, state.endDate, state.demandVariant);
            if (typeof findedFirstAvailableDate !== "undefined") {
                var startDate = findedFirstAvailableDate.startDate, endDate = findedFirstAvailableDate.endDate;
                if (startDate !== state.startDate) {
                    dispatch({
                        type: "startDate",
                        payload: startDate
                    });
                }
                if (endDate !== state.endDate) {
                    dispatch({
                        type: "endDate",
                        payload: endDate
                    });
                }
            }
        }
    }, [
        state.demandVariant,
        mappedReservedTimes
    ]);
    return {
        isDateAvailable: isDateAvailable,
        isDateRangeAvailable: isDateRangeAvailable
    };
}

// EXTERNAL MODULE: ./src/components/Form/BSwitch.tsx
var BSwitch = __webpack_require__(12568);
// EXTERNAL MODULE: ./src/enums/currency.ts
var currency = __webpack_require__(85032);
// EXTERNAL MODULE: ./src/services/AnalyticsService.ts
var AnalyticsService = __webpack_require__(40515);
// EXTERNAL MODULE: ./src/enums/vehiclePriceUnit.ts
var vehiclePriceUnit = __webpack_require__(82871);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDWGetOffsetDays.ts



function usePriceWidgetDWGetOffsetDays(param) {
    var state = param.state, rentalInfo = param.rentalInfo;
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var minimumRentDuration = rentalInfo.minimumRentDuration;
    var startDate = state.startDate;
    var offsetDays = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(Array(minimumRentDuration - 1)).map(function(_, idx) {
            return dayjs(startDate).add(+idx + 1, "day").toDate();
        });
    }, [
        minimumRentDuration,
        dayjs,
        startDate
    ]);
    return {
        offsetDays: offsetDays
    };
}

// EXTERNAL MODULE: ./src/components/Form/BTextArea.tsx
var BTextArea = __webpack_require__(49501);
// EXTERNAL MODULE: ./src/components/common/BButton.tsx
var BButton = __webpack_require__(87114);
// EXTERNAL MODULE: ./src/components/common/BSpinnerInline.tsx
var BSpinnerInline = __webpack_require__(22773);
// EXTERNAL MODULE: ./src/states/useRemoteConfigState.ts
var useRemoteConfigState = __webpack_require__(18027);
// EXTERNAL MODULE: ./src/utils/getLocalePrefix.ts
var getLocalePrefix = __webpack_require__(14211);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetDailyWeeklyForm.tsx














































var PriceWidgetDailyWeeklyForm = function(param) {
    var supportedServices = param.supportedServices, cruisingCapacity = param.cruisingCapacity, overnightCapacity = param.overnightCapacity, vehicleId = param.vehicleId, setPricing = param.setPricing, rentalInfo = param.rentalInfo, reservedTimes = param.reservedTimes, originHarborId = param.originHarborId, supportedDemandTypes = param.supportedDemandTypes, pricing = param.pricing, harbors = param.harbors, isCalculateAmountRequestSent = param.isCalculateAmountRequestSent, setIsCalculateAmountRequestSent = param.setIsCalculateAmountRequestSent, vehicleName = param.vehicleName, vehicleType = param.vehicleType, regionTRName = param.regionTRName, isCalcutePricingRequestOngoing = param.isCalcutePricingRequestOngoing, setIsCalcutePricingRequestOngoing = param.setIsCalcutePricingRequestOngoing, _submitType = param.submitType, submitType = _submitType === void 0 ? "default" : _submitType, _demandId = param.demandId, demandId = _demandId === void 0 ? null : _demandId, submitCallback = param.submitCallback, demandData = param.demandData;
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var router = (0,next_router.useRouter)();
    var translateAndNavigate = (0,useTranslatedNavigation/* useTranslatedNavigation */.v)().translateAndNavigate;
    var t = (0,useTranslation/* default */.Z)("vehicle").t;
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var ref = (0,useQueryParams/* useQueryParams */.K)(), addQueryParam = ref.addQueryParam, getQueryParam = ref.getQueryParam;
    var checkLoggedIn = (0,useAuthCheck/* useAuthCheck */.P)().checkLoggedIn;
    var ref1 = (0,react.useState)(""), message = ref1[0], setMessage = ref1[1];
    var getConfig = (0,useRemoteConfigState/* useRemoteConfigState */.l)().getConfig;
    var isMessagingActive = getConfig("MESSAGING_ENABLED", true);
    var ref2 = usePriceWidgetCalculateDWDuration(rentalInfo), calculateDWDemandVariant = ref2.calculateDWDemandVariant, formatDatesToCorrectHours = ref2.formatDatesToCorrectHours, getDemandDWDuration = ref2.getDemandDWDuration;
    var ref3 = (0,react.useState)(false), isDemandRequestOngoing = ref3[0], setIsDemandRequestOngoing = ref3[1];
    var validateForm = function(state, showError) {
        return (0,demand_validation/* vehicleBasedDWValidation */.W)(state, 0, cruisingCapacity, overnightCapacity, t, showError);
    };
    var debouncedHandleCalculateAmounts = usePriceWidgetDWCalculateAmounts(vehicleId, supportedServices, setPricing, supportedDemandTypes, validateForm, setIsCalculateAmountRequestSent, setIsCalcutePricingRequestOngoing, pricing, rentalInfo).debouncedHandleCalculateAmounts;
    var generateSelectedExtraUnits = function(supportedExtras) {
        return supportedExtras.reduce(function(acc, item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, item.id, null));
        }, {});
    };
    var getDefaultDemandVariant = function() {
        return rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY) ? supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY : rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY) ? supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY : supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY;
    };
    var resetDay = function(day) {
        return day.hour(0).minute(0).second(0).millisecond(0).toDate();
    };
    var getDefaultState = (0,react.useCallback)(function() {
        var isHalfDay = getQueryParam("halfDay") === "true";
        var demandVariant = supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY;
        if (isHalfDay) {
            demandVariant = supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY;
        } else {
            demandVariant = getDefaultDemandVariant();
        }
        if (demandData) {
            demandVariant = demandData.dwVariant;
        }
        var _obj;
        var endDateOffset = (_obj = {}, (0,_define_property/* default */.Z)(_obj, supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.DAILY */.N.DAILY, 1), (0,_define_property/* default */.Z)(_obj, supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY, 7), (0,_define_property/* default */.Z)(_obj, supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY, 0), _obj)[demandVariant];
        var queryParamState = {
            startDate: getQueryParam("startDate"),
            endDate: getQueryParam("endDate"),
            numberOfPeople: getQueryParam("numberOfPeople"),
            selectedServices: getQueryParam("selectedServices")
        };
        var startDate = resetDay(dayjs(queryParamState.startDate ? +queryParamState.startDate : undefined));
        if (demandData === null || demandData === void 0 ? void 0 : demandData.startTime) {
            startDate = resetDay(dayjs(demandData === null || demandData === void 0 ? void 0 : demandData.startTime));
        }
        var endDate = resetDay(queryParamState.endDate ? dayjs(+queryParamState.endDate) : dayjs(startDate).add(endDateOffset, "days"));
        if (demandData === null || demandData === void 0 ? void 0 : demandData.endTime) {
            endDate = resetDay(dayjs(demandData === null || demandData === void 0 ? void 0 : demandData.endTime));
        }
        var harbor = "".concat(originHarborId);
        var endHarbor = "".concat(originHarborId);
        if ((demandData === null || demandData === void 0 ? void 0 : demandData.startHarbor) && (demandData === null || demandData === void 0 ? void 0 : demandData.finishHarbor)) {
            var ref, ref1;
            harbor = "" + ((ref = harbors.find(function(h) {
                return h.label === (demandData === null || demandData === void 0 ? void 0 : demandData.startHarbor);
            })) === null || ref === void 0 ? void 0 : ref.value);
            endHarbor = "" + ((ref1 = harbors.find(function(h) {
                return h.label === (demandData === null || demandData === void 0 ? void 0 : demandData.finishHarbor);
            })) === null || ref1 === void 0 ? void 0 : ref1.value);
        }
        var maxLimit = demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY ? cruisingCapacity : overnightCapacity;
        var numberOfPeople = queryParamState.numberOfPeople && +queryParamState.numberOfPeople > 0 && +queryParamState.numberOfPeople <= maxLimit ? queryParamState.numberOfPeople : "0";
        if (demandData === null || demandData === void 0 ? void 0 : demandData.passengerCount) {
            numberOfPeople = "" + (demandData === null || demandData === void 0 ? void 0 : demandData.passengerCount);
        }
        var selectedServices = (demandData === null || demandData === void 0 ? void 0 : demandData.services.map(function(s) {
            return s.id;
        })) || [];
        if (queryParamState.selectedServices && queryParamState.selectedServices.length > 0) {
            queryParamState.selectedServices.forEach(function(s) {
                if (supportedServices.find(function(ss) {
                    return ss.id === +s;
                })) {
                    selectedServices.push(+s);
                }
            });
        }
        if (demandData === null || demandData === void 0 ? void 0 : demandData.services) {
            demandData === null || demandData === void 0 ? void 0 : demandData.services.forEach(function(s) {
                if (supportedServices.find(function(ss) {
                    return ss.id === +s;
                })) {
                    selectedServices.push(+s);
                }
            });
        }
        return {
            startDate: startDate,
            endDate: endDate,
            harbor: harbor,
            endHarbor: endHarbor,
            numberOfPeople: numberOfPeople,
            selectedServices: selectedServices,
            selectedServicesUnits: generateSelectedExtraUnits(supportedServices),
            demandVariant: demandVariant
        };
    }, []);
    var dispatchInterceptor = function(state) {
        var ref, ref1;
        debouncedHandleCalculateAmounts(state);
        // setStoredState(state);
        var strippedState = {
            startDate: (ref = state.startDate) === null || ref === void 0 ? void 0 : ref.getTime(),
            endDate: (ref1 = state.endDate) === null || ref1 === void 0 ? void 0 : ref1.getTime(),
            numberOfPeople: state.numberOfPeople,
            selectedServices: state.selectedServices,
            halfDay: state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY
        };
        submitType !== "message-update" && addQueryParam(strippedState);
    };
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useForm/* useForm */.c)((0,_object_spread/* default */.Z)({}, getDefaultState()), dispatchInterceptor), 2), state = ref4[0], dispatch = ref4[1];
    (0,react.useEffect)(function() {
        debouncedHandleCalculateAmounts(state);
    }, []);
    var mappedReservedTimes = usePriceWidgetDWReservedTimes({
        state: state,
        reservedTimes: reservedTimes,
        rentalInfo: rentalInfo
    }).mappedReservedTimes;
    var ref5 = usePriceWidgetDWAvailableDays(rentalInfo, state), getDisabledDays = ref5.getDisabledDays, disableDatesBeforeToday = ref5.disableDatesBeforeToday;
    var isDateRangeAvailable = usePriceWidgetDWClosestAvailability({
        state: state,
        dispatch: dispatch,
        mappedReservedTimes: mappedReservedTimes,
        getDisabledDays: getDisabledDays,
        disableDatesBeforeToday: disableDatesBeforeToday
    }).isDateRangeAvailable;
    var ref6 = usePriceWidgetDWPeopleLimits(state, dispatch, cruisingCapacity, overnightCapacity), MAX_PEOPLE = ref6.MAX_PEOPLE, MIN_PEOPLE = ref6.MIN_PEOPLE;
    var extraTabs = (0,usePriceWidgetExtraSections/* usePriceWidgetExtraSections */.K)(state, dispatch, [], [], supportedServices, 0).extraTabs;
    var offsetDays = usePriceWidgetDWGetOffsetDays({
        state: state,
        rentalInfo: rentalInfo
    }).offsetDays;
    var doesSupportHalfDayRental = (0,react.useMemo)(function() {
        return rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY);
    }, [
        rentalInfo.supportedRentalTypes
    ]);
    var doesSupportOnlyHalfDayRental = (0,react.useMemo)(function() {
        return doesSupportHalfDayRental && rentalInfo.supportedRentalTypes.length === 1;
    }, [
        rentalInfo.supportedRentalTypes,
        doesSupportHalfDayRental
    ]);
    var clearUnsupportedExtras = function() {
        var stateServices = state["selectedServices"];
        var selectedServices = stateServices.filter(function(service) {
            return supportedServices.some(function(supportedService) {
                return supportedService.id === service;
            });
        });
        return {
            selectedServices: selectedServices
        };
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var clearedExtras, demandVariant, filteredState, duration, calculatedDuration, isValid, payload, ref, ref1, ref2, res, ref3, ref4, ref5, ref6, ref7, ref8, res1, ref9, ref10, ref11;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        clearedExtras = clearUnsupportedExtras();
                        demandVariant = calculateDWDemandVariant(state);
                        filteredState = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            demandVariant: demandVariant,
                            selectedServices: clearedExtras.selectedServices
                        }), formatDatesToCorrectHours(state));
                        duration = getDemandDWDuration(filteredState);
                        if (filteredState.demandVariant !== supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY) {
                            calculatedDuration = duration;
                            if (filteredState.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.WEEKLY */.N.WEEKLY) {
                                calculatedDuration *= 7;
                            }
                            if (calculatedDuration < rentalInfo.minimumRentDuration) {
                                react_toastify_esm/* toast.error */.Am.error(t("priceWidget.form.errors.lessThanMinimumRentDuration", {
                                    count: rentalInfo.minimumRentDuration
                                }), {
                                    toastId: "lessThanMinimumRentDuration"
                                });
                                return [
                                    2,
                                    false
                                ];
                            }
                        }
                        return [
                            4,
                            validateForm(filteredState, true)
                        ];
                    case 1:
                        isValid = _state.sent();
                        if (!isValid) return [
                            2,
                            false
                        ];
                        if (state.startDate && state.endDate && !isDateRangeAvailable({
                            startDate: state.startDate,
                            endDate: state.endDate
                        })) {
                            react_toastify_esm/* toast.error */.Am.error(t("priceWidget.form.errors.dateNotValid"), {
                                toastId: "noValidDate"
                            });
                            return [
                                2,
                                false
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            ,
                            9,
                            10
                        ]);
                        setIsDemandRequestOngoing(true);
                        payload = DemandService/* demandService.formatVehicleBasedDWDemandStateToDemand */.l.formatVehicleBasedDWDemandStateToDemand(filteredState, vehicleId, (0,_to_consumable_array/* default */.Z)(supportedServices), pricing, duration);
                        if (!(submitType === "default")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            DemandService/* demandService.createDemand */.l.createDemand((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "API"
                            }))
                        ];
                    case 3:
                        res = _state.sent();
                        AnalyticsService/* analyticsService.addToCartVehicleBased */.I.addToCartVehicleBased({
                            vehicleId: vehicleId,
                            totalPrice: (ref3 = (ref = payload.paymentInfo) === null || ref === void 0 ? void 0 : ref.totalAmount) !== null && ref3 !== void 0 ? ref3 : 0,
                            currency: (ref4 = (ref1 = payload.paymentInfo) === null || ref1 === void 0 ? void 0 : ref1.currency) !== null && ref4 !== void 0 ? ref4 : currency/* Currency.TRY */.F.TRY,
                            duration: duration,
                            hourlyPrice: (ref5 = (ref2 = payload.paymentInfo) === null || ref2 === void 0 ? void 0 : ref2.vehicleCostPerUnit) !== null && ref5 !== void 0 ? ref5 : 0,
                            region: regionTRName,
                            vehicleName: vehicleName,
                            vehicleType: vehicleType,
                            vehiclePriceUnit: (pricing === null || pricing === void 0 ? void 0 : pricing.priceUnit) || vehiclePriceUnit/* VehiclePriceUnit.DAY */.k.DAY
                        });
                        if (res.offerId) {
                            window.open("".concat((0,getLocalePrefix/* getLocalePrefix */.A)(locale), "payment/").concat(res.offerId), "_self");
                        } else {
                            react_toastify_esm/* toast.success */.Am.success(t("priceWidget.demandSuccess"), {
                                toastId: "demandSuccess"
                            });
                            if (isMessagingActive) {
                                translateAndNavigate("/message?demandId=".concat(res.demandId));
                            } else {
                                translateAndNavigate("/tekliflerim");
                            }
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(submitType === "message")) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            DemandService/* demandService.createDemand */.l.createDemand((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                initialMessage: message,
                                source: "MESSAGE"
                            }))
                        ];
                    case 5:
                        res1 = _state.sent();
                        AnalyticsService/* analyticsService.addToCartVehicleBased */.I.addToCartVehicleBased({
                            vehicleId: vehicleId,
                            totalPrice: (ref9 = (ref6 = payload.paymentInfo) === null || ref6 === void 0 ? void 0 : ref6.totalAmount) !== null && ref9 !== void 0 ? ref9 : 0,
                            currency: (ref10 = (ref7 = payload.paymentInfo) === null || ref7 === void 0 ? void 0 : ref7.currency) !== null && ref10 !== void 0 ? ref10 : currency/* Currency.TRY */.F.TRY,
                            duration: duration,
                            hourlyPrice: (ref11 = (ref8 = payload.paymentInfo) === null || ref8 === void 0 ? void 0 : ref8.vehicleCostPerUnit) !== null && ref11 !== void 0 ? ref11 : 0,
                            region: regionTRName,
                            vehicleName: vehicleName,
                            vehicleType: vehicleType,
                            vehiclePriceUnit: (pricing === null || pricing === void 0 ? void 0 : pricing.priceUnit) || vehiclePriceUnit/* VehiclePriceUnit.DAY */.k.DAY
                        });
                        router.push("/message?demandId=".concat(res1.demandId));
                        return [
                            3,
                            8
                        ];
                    case 6:
                        if (!(submitType === "message-update" && demandId)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            DemandService/* demandService.updateDemand */.l.updateDemand(demandId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "MESSAGE"
                            }))
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        submitCallback === null || submitCallback === void 0 ? void 0 : submitCallback();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsDemandRequestOngoing(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var formItemClasses = "pb-2.5 pt-1 px-3";
    var formLabelClasses = "text-sm font-semibold mb-1 inline-block";
    var formBorderColor = "border-slate-500";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("form mt-3 grid grid-cols-2 rounded-2xl border", formBorderColor),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(formItemClasses, formBorderColor, "col-span-2 border-b"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_BDateRangePicker, {
                            isRange: state.demandVariant !== supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY,
                            fixedHeight: true,
                            labelClasses: formLabelClasses,
                            disabledDay: function(date) {
                                return offsetDays.includes(date) || getDisabledDays(date);
                            },
                            disabledDates: mappedReservedTimes,
                            rangeLabels: {
                                firstInput: t("priceWidget.form.checkInDate"),
                                lastInput: t("priceWidget.form.checkOutDate")
                            },
                            nonRangeLabel: t("priceWidget.form.checkInDate"),
                            ranges: [
                                {
                                    startDate: state.startDate || new Date(),
                                    endDate: state.endDate || new Date(),
                                    key: "state"
                                }, 
                            ],
                            onChange: function(val) {
                                dispatch({
                                    type: "startDate",
                                    payload: val.state.startDate
                                });
                                dispatch({
                                    type: "endDate",
                                    payload: val.state.endDate
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-2 pt-1 pb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BSwitch/* default */.Z, {
                                        value: state.demandVariant === supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY,
                                        disabled: !doesSupportHalfDayRental,
                                        labelClasses: "text-info-600",
                                        onChange: function(val) {
                                            dispatch({
                                                type: "REPLACE_STATE",
                                                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                                    demandVariant: val ? supportedRentalTypes/* SupportedDailyWeeklyRentalTypes.HALF_DAY */.N.HALF_DAY : getDefaultDemandVariant(),
                                                    endDate: state.startDate
                                                })
                                            });
                                        },
                                        label: t("priceWidget.form.halfDay")
                                    }),
                                    doesSupportHalfDayRental ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mt-1 inline-block text-sm text-slate-500",
                                        children: t("priceWidget.form.halfDayInfo")
                                    }) : null,
                                    doesSupportOnlyHalfDayRental ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mt-1 inline-block text-sm text-slate-500",
                                        children: t("priceWidget.form.halfDayOnlySupported")
                                    }) : null,
                                    !doesSupportHalfDayRental ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mt-1 inline-block text-sm text-slate-500",
                                        children: t("priceWidget.form.halfDayNotSupported")
                                    }) : null
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(formItemClasses, formBorderColor, "col-span-2"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: formLabelClasses,
                                htmlFor: "number-of-people",
                                children: t("priceWidget.form.personCount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BStepperInput/* default */.Z, {
                                    inputProps: {
                                        id: "number-of-people"
                                    },
                                    minLimit: MIN_PEOPLE,
                                    maxLimit: MAX_PEOPLE,
                                    value: state.numberOfPeople,
                                    inputEnabled: true,
                                    boundaryErrorKey: "vehicle:priceWidget.form.personCountBoundaryError",
                                    onChange: function(value) {
                                        return dispatch({
                                            type: "numberOfPeople",
                                            payload: "".concat(value)
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithActivator/* default */.Z, {
                modalTitle: t("priceWidget.form.extrasModal.title"),
                activator: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtras/* default */.Z, {}),
                modalClass: "h-screen",
                children: extraTabs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BTabs/* default */.Z, {
                    tabs: extraTabs
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtrasEmptyView/* default */.Z, {})
            }),
            submitType === "message" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BTextArea/* default */.Z, {
                value: message,
                onChange: function(e) {
                    return setMessage(e.target.value);
                },
                className: "mt-4"
            }) : null,
            submitType === "default" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetCTAButton/* default */.Z, {
                className: "mt-4",
                fluid: true,
                onClick: onSubmit,
                supportedDemandTypes: supportedDemandTypes,
                pricing: pricing,
                isCalculateAmountRequestSent: isCalculateAmountRequestSent,
                isCalcutePricingRequestOngoing: isCalcutePricingRequestOngoing,
                isDemandRequestOngoing: isDemandRequestOngoing
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                className: "mt-4",
                fluid: true,
                onClick: onSubmit,
                disabled: isDemandRequestOngoing,
                children: isDemandRequestOngoing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSpinnerInline/* default */.Z, {
                    size: 24,
                    className: "mx-auto"
                }) : submitType === "message" ? t("message.cta") : t("update.cta")
            })
        ]
    });
};
/* harmony default export */ var PriceWidget_PriceWidgetDailyWeeklyForm = (PriceWidgetDailyWeeklyForm);


/***/ }),

/***/ 10855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var components_common_BButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87114);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56787);



var PriceWidgetExtras = function() {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("vehicle").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "mx-auto mt-4 block text-sm",
        variant: "info",
        priority: "contained",
        type: "button",
        children: t("priceWidget.selectExtra")
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PriceWidgetExtras);


/***/ }),

/***/ 41905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PriceWidget_PriceWidgetForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(80072);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59354);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36840);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(50132);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/common/BAlert.tsx + 1 modules
var BAlert = __webpack_require__(84917);
// EXTERNAL MODULE: ./src/components/common/BTabs.tsx
var BTabs = __webpack_require__(52940);
// EXTERNAL MODULE: ./src/components/common/ModalWithActivator.tsx
var ModalWithActivator = __webpack_require__(30013);
// EXTERNAL MODULE: ./src/components/Form/BDatePicker.tsx
var BDatePicker = __webpack_require__(28933);
// EXTERNAL MODULE: ./src/components/Form/BStepperInput.tsx + 2 modules
var BStepperInput = __webpack_require__(32600);
// EXTERNAL MODULE: ./src/components/Form/BSwitch.tsx
var BSwitch = __webpack_require__(12568);
// EXTERNAL MODULE: ./src/enums/currency.ts
var currency = __webpack_require__(85032);
// EXTERNAL MODULE: ./src/enums/SupportedDemandType.ts
var SupportedDemandType = __webpack_require__(7794);
// EXTERNAL MODULE: ./src/enums/vehicleTypes.ts
var vehicleTypes = __webpack_require__(65014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/services/DemandService.ts + 1 modules
var DemandService = __webpack_require__(57441);
// EXTERNAL MODULE: ./node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(78480);
// EXTERNAL MODULE: ./src/hooks/priceWidget/useCheckPricingExists.ts
var useCheckPricingExists = __webpack_require__(188);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetCalculateAmounts.ts









function usePriceWidgetCalculateAmounts(vehicleId, supportedServices, supportedPackages, setPricing, supportedDemandTypes, validateForm, setIsCalculateAmountRequestSent, setIsCalcutePricingRequestOngoing, pricing) {
    var checkPricingExists = (0,useCheckPricingExists/* useCheckPricingExists */.D)(supportedDemandTypes).checkPricingExists;
    var handleCalculateAmounts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(state) {
            var localState, isValid, payload, pricings;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkPricingExists()) return [
                            2,
                            false
                        ];
                        setIsCalcutePricingRequestOngoing(false);
                        localState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            numberOfPeople: +state.numberOfPeople === 0 ? "1" : "".concat(state.numberOfPeople)
                        });
                        return [
                            4,
                            validateForm(localState, false)
                        ];
                    case 1:
                        isValid = _state.sent();
                        if (!isValid) return [
                            2,
                            false
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            ,
                            4,
                            5
                        ]);
                        !pricing && setIsCalcutePricingRequestOngoing(true);
                        payload = DemandService/* demandService.formatVehicleBasedDemandStateToDemand */.l.formatVehicleBasedDemandStateToDemand(localState, vehicleId, (0,_to_consumable_array/* default */.Z)(supportedServices).concat((0,_to_consumable_array/* default */.Z)(supportedPackages)), undefined);
                        return [
                            4,
                            DemandService/* demandService.calculatePricing */.l.calculatePricing((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "API"
                            }))
                        ];
                    case 3:
                        pricings = _state.sent();
                        setPricing((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pricings), {
                            duration: +state.duration
                        }));
                        setIsCalculateAmountRequestSent(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsCalcutePricingRequestOngoing(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCalculateAmounts(state) {
            return _ref.apply(this, arguments);
        };
    }();
    var debouncedHandleCalculateAmounts = (0,index_module/* useDebouncedCallback */.y1)(handleCalculateAmounts, 500);
    (0,react.useEffect)(function() {
        return function() {
            debouncedHandleCalculateAmounts.flush();
        };
    }, [
        debouncedHandleCalculateAmounts
    ]);
    return {
        handleCalculateAmounts: handleCalculateAmounts,
        debouncedHandleCalculateAmounts: debouncedHandleCalculateAmounts
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(73149);
// EXTERNAL MODULE: ./src/services/DateService.ts
var DateService = __webpack_require__(49163);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetHourGenerator.ts

function usePriceWidgetHourGenerator() {
    var generateHourArray = (0,react.useCallback)(function() {
        return new Array(24).fill(0).map(function(_, idx) {
            return +idx;
        });
    }, []);
    var generateHourArrayWithoutTen = (0,react.useCallback)(function() {
        var hoursInADay = generateHourArray();
        var idxOfTen = 10;
        hoursInADay.splice(idxOfTen, 1);
        return hoursInADay;
    }, []);
    return {
        generateHourArray: generateHourArray,
        generateHourArrayWithoutTen: generateHourArrayWithoutTen
    };
}

// EXTERNAL MODULE: ./src/hooks/useQueryParams.ts
var useQueryParams = __webpack_require__(78285);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetClosestAvailability.ts







function usePriceWidgetClosestAvailability(state, dispatch, mappedReservedTimes, datePickerDisabledHours, demandData) {
    var generateHourArray = usePriceWidgetHourGenerator().generateHourArray;
    var calculatedDatesMap = (0,react.useRef)([]);
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var getQueryParam = (0,useQueryParams/* useQueryParams */.K)().getQueryParam;
    var isFindFirstAvailableHourFirstLoop = (0,react.useRef)(true);
    var morningHours = {
        start: 8,
        end: 18
    };
    var constructSchedule = function(date) {
        var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date);
        var _formattedDate;
        var currentReservedTimes = (0,_to_consumable_array/* default */.Z)((_formattedDate = mappedReservedTimes[formattedDate]) !== null && _formattedDate !== void 0 ? _formattedDate : []);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var offsetTime = _step.value;
                var intersectedReservedTime = currentReservedTimes.find(function(time) {
                    return time.hour === offsetTime.hour;
                });
                if (intersectedReservedTime) {
                    intersectedReservedTime = {
                        hour: intersectedReservedTime.hour,
                        harborId: intersectedReservedTime.harborId,
                        isOffset: offsetTime.isOffset && intersectedReservedTime.isOffset
                    };
                } else {
                    currentReservedTimes.push((0,_object_spread/* default */.Z)({}, offsetTime));
                }
            };
            for(var _iterator = datePickerDisabledHours[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return (0,_to_consumable_array/* default */.Z)(currentReservedTimes).sort(function(a, b) {
            return a.hour - b.hour;
        });
    };
    var findFirstUnavailableHour = function(schedule, startHour) {
        return schedule.sort(function(a, b) {
            return a.hour - b.hour;
        }).find(function(d) {
            return d.hour > startHour && !d.isOffset;
        });
    };
    var checkIfDateAvailable = function(hour, date, schedule, dayOffset) {
        var fromQueryParam = getQueryParam("date") ? date.isSame(dayjs(Number(getQueryParam("date"))), "hour") : false;
        var fromDemandData = (demandData === null || demandData === void 0 ? void 0 : demandData.startTime) ? date.isSame(dayjs(demandData.startTime), "hour") : false;
        var isFirstLoop = isFindFirstAvailableHourFirstLoop.current;
        var disabledHoursIfFirstLoop = dayOffset < 7 && isFirstLoop && !fromQueryParam && !fromDemandData && (hour < morningHours.start || hour >= morningHours.end);
        if (disabledHoursIfFirstLoop) return false;
        var isNotInSchedule = schedule.every(function(h) {
            return h.hour !== hour;
        });
        var isLaterThanToday = date.hour(hour).toDate().getTime() > new Date().getTime();
        return isNotInSchedule && isLaterThanToday;
    };
    var isDateAvailable = function(date) {
        var schedule = constructSchedule(date);
        var dayjsDate = dayjs(date);
        var hour = dayjsDate.hour();
        return checkIfDateAvailable(hour, dayjsDate, schedule, 0);
    };
    var findFirstAvailableHour = function(date, isSwimmingTour) {
        var _loop = function() {
            var toBeCalculatedDate = dayjs(date).minute(0).add(currentDayOffset, "day");
            var toBeCalculatedDateHour = toBeCalculatedDate.hour();
            var schedule = constructSchedule(toBeCalculatedDate.toDate());
            if (isSwimmingTour) {
                if (checkIfDateAvailable(10, toBeCalculatedDate, schedule, currentDayOffset)) {
                    return {
                        v: toBeCalculatedDate.hour(10).toDate()
                    };
                }
            } else {
                if (checkIfDateAvailable(toBeCalculatedDateHour, toBeCalculatedDate, schedule, currentDayOffset)) {
                    return {
                        v: toBeCalculatedDate.toDate()
                    };
                }
                var startOfToBeCalculatedDate = toBeCalculatedDate.startOf("day");
                var availableHour = hourArray.find(function(hour) {
                    return checkIfDateAvailable(hour, startOfToBeCalculatedDate, schedule, currentDayOffset);
                });
                findedClosestAvailability = availableHour !== undefined ? toBeCalculatedDate.hour(availableHour).toDate() : null;
            }
            currentDayOffset++;
            if (currentDayOffset > 5 * 30) {
                return "break";
            }
        };
        var hourArray = generateHourArray();
        var findedClosestAvailability = null;
        var currentDayOffset = 0;
        while(findedClosestAvailability === null){
            var _ret = _loop();
            if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
            if (_ret === "break") break;
        }
        return findedClosestAvailability;
    };
    (0,react.useEffect)(function() {
        if (state.date) {
            var generateMap = {
                date: state.date,
                isSwimmingTour: state.isSwimmingTour
            };
            var isCalculated = calculatedDatesMap.current.find(function(item) {
                return item.date.getTime() === generateMap.date.getTime() && item.isSwimmingTour === generateMap.isSwimmingTour;
            });
            if (!isCalculated) {
                var findedFirstAvailableDate = findFirstAvailableHour(state.date, state.isSwimmingTour);
                isFindFirstAvailableHourFirstLoop.current = false;
                if (findedFirstAvailableDate && findedFirstAvailableDate.getTime() !== state.date.getTime()) {
                    dispatch({
                        type: "date",
                        payload: findedFirstAvailableDate
                    });
                    generateMap.changedToDate = findedFirstAvailableDate;
                }
                calculatedDatesMap.current.push(generateMap);
            } else if (isCalculated.changedToDate) {
                dispatch({
                    type: "date",
                    payload: isCalculated.changedToDate
                });
            }
        }
    }, [
        state.isSwimmingTour,
        mappedReservedTimes,
        datePickerDisabledHours
    ]);
    return {
        constructSchedule: constructSchedule,
        findFirstUnavailableHour: findFirstUnavailableHour,
        findFirstAvailableHour: findFirstAvailableHour,
        isDateAvailable: isDateAvailable
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetIsSpecialDate.ts

function usePriceWidgetIsSpecialDate(rentalInfo) {
    var getIsSpecialDate = function(date) {
        var ref;
        return (ref = rentalInfo.specialDayFactors) === null || ref === void 0 ? void 0 : ref.some(function(sp) {
            var specialDate = DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(sp.date);
            return DateService/* dateService.isSameDate */.o.isSameDate(date, specialDate);
        });
    };
    return {
        getIsSpecialDate: getIsSpecialDate
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDisabledHours.ts





function usePriceWidgetDisabledHours(state, supportedDemandTypes, rentalInfo) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var getIsSpecialDate = usePriceWidgetIsSpecialDate(rentalInfo).getIsSpecialDate;
    var calculateDisabledHoursByDate = function(date) {
        if (supportedDemandTypes.includes(SupportedDemandType/* SupportedDemandType.IMMEDIATE_RESERVATION */.g.IMMEDIATE_RESERVATION) && rentalInfo.operationalHours && rentalInfo.operationalHours.end !== rentalInfo.operationalHours.start && date) {
            var resultArray = [];
            var isSpecialDate = getIsSpecialDate(date);
            var rentalDurationOffset = (isSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration) - 1;
            var nextDate = dayjs(date).add(1, "day");
            var isNextDateSpecialDate = getIsSpecialDate(nextDate.toDate());
            var nextDateRentalDurationOffset = (isNextDateSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration) - 1;
            var opHours = rentalInfo.operationalHours;
            var offsetTime = opHours.end < nextDateRentalDurationOffset ? Math.max(rentalDurationOffset, nextDateRentalDurationOffset) : rentalDurationOffset;
            var offsetedEndTime = opHours.end - offsetTime;
            var endTime = offsetedEndTime < 0 ? 24 + offsetedEndTime : offsetedEndTime;
            var isOffset = function(hour) {
                if (endTime <= opHours.end) {
                    return hour >= endTime && hour < opHours.end;
                }
                return hour >= endTime || hour < opHours.end;
            };
            if (endTime < opHours.start) {
                (0,_to_consumable_array/* default */.Z)(Array(24)).forEach(function(_, idx) {
                    if (!(idx >= opHours.start || idx < endTime)) {
                        resultArray.push({
                            hour: idx,
                            isOffset: isOffset(idx)
                        });
                    }
                });
            } else {
                (0,_to_consumable_array/* default */.Z)(Array(24)).forEach(function(_, idx) {
                    if (idx < opHours.start || idx >= endTime) {
                        resultArray.push({
                            hour: idx,
                            isOffset: isOffset(idx)
                        });
                    }
                });
            }
            return resultArray;
        }
        return [];
    };
    var datePickerDisabledHours = (0,react.useMemo)(function() {
        return calculateDisabledHoursByDate(state.date);
    }, [
        rentalInfo.operationalHours,
        supportedDemandTypes,
        state.date
    ]);
    return {
        datePickerDisabledHours: datePickerDisabledHours
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetDurationLimits.ts




function usePriceWidgetDurationLimits(state, dispatch, rentalInfo, mappedReservedTimes, datePickerDisabledHours, demandData) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var getIsSpecialDate = usePriceWidgetIsSpecialDate(rentalInfo).getIsSpecialDate;
    var ref = usePriceWidgetClosestAvailability(state, dispatch, mappedReservedTimes, datePickerDisabledHours, demandData), constructSchedule = ref.constructSchedule, findFirstUnavailableHour = ref.findFirstUnavailableHour;
    var MIN_DURATION = (0,react.useMemo)(function() {
        if (state.isSwimmingTour) {
            return 8;
        }
        if (state.date && rentalInfo.specialDayFactors) {
            var isSpecialDate = getIsSpecialDate(state.date);
            if (isSpecialDate) {
                return rentalInfo.minimumRentDurationOnSpecialDays;
            }
        }
        var _minimumRentDuration;
        return (_minimumRentDuration = rentalInfo.minimumRentDuration) !== null && _minimumRentDuration !== void 0 ? _minimumRentDuration : 1;
    }, [
        state.duration,
        state.date,
        state.isSwimmingTour
    ]);
    var MAX_DURATION = (0,react.useMemo)(function() {
        if (state.isSwimmingTour) {
            return 8;
        }
        var maxDuration = 12;
        var minLimit = rentalInfo.minimumRentDuration;
        if (state.date) {
            var isSpecialDate = getIsSpecialDate(state.date);
            minLimit = isSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration;
            var currentHour = dayjs(state.date).hour();
            var todaysSchedule = constructSchedule(state.date);
            var firstFilledHourAfterCurrentHourToday = findFirstUnavailableHour(todaysSchedule, currentHour);
            if (firstFilledHourAfterCurrentHourToday) {
                maxDuration = firstFilledHourAfterCurrentHourToday.hour - currentHour;
            } else {
                var tomorrow = dayjs(state.date).add(1, "day").toDate();
                var tomorrowsSchedule = constructSchedule(tomorrow);
                var firstFilledHourAfterCurrentHourTomorrow = tomorrowsSchedule === null || tomorrowsSchedule === void 0 ? void 0 : tomorrowsSchedule.find(function(d) {
                    return !d.isOffset;
                });
                if (firstFilledHourAfterCurrentHourTomorrow) {
                    var firstAvailableHour = 24 + firstFilledHourAfterCurrentHourTomorrow.hour - currentHour;
                    maxDuration = firstAvailableHour;
                }
            }
        }
        return Math.min(Math.max(maxDuration, minLimit), 12);
    }, [
        state.isSwimmingTour,
        state.date
    ]);
    (0,react.useEffect)(function() {
        if (MIN_DURATION > state.duration) {
            dispatch({
                type: "duration",
                payload: MIN_DURATION
            });
        }
    }, [
        MIN_DURATION
    ]);
    (0,react.useEffect)(function() {
        if (MAX_DURATION < state.duration) {
            dispatch({
                type: "duration",
                payload: MAX_DURATION
            });
        }
    }, [
        MAX_DURATION
    ]);
    return {
        MIN_DURATION: MIN_DURATION,
        MAX_DURATION: MAX_DURATION
    };
}

// EXTERNAL MODULE: ./src/hooks/priceWidget/usePriceWidgetExtraSections.tsx
var usePriceWidgetExtraSections = __webpack_require__(21052);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetHarborIntersections.ts


function usePriceWidgetHarborIntersections(state, dispatch, mappedReservedTimes) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var ref = (0,react.useState)(null), lockHarborsOtherThanThis = ref[0], setLockHarborsOtherThanThis = ref[1];
    var checkInterception = function(date, isStart) {
        var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date);
        var hour = dayjs(date).hour();
        var rezervedTimeForDate = mappedReservedTimes[formattedDate];
        var offset = isStart ? -1 : 0;
        if (isStart && hour === 0) {
            var yesterday = dayjs(date).subtract(1, "day").toDate();
            var formattedYesterday = DateService/* dateService.getFormattedDate */.o.getFormattedDate(yesterday);
            rezervedTimeForDate = mappedReservedTimes[formattedYesterday];
            offset = 23;
        }
        if (rezervedTimeForDate) {
            var previousReservedHour = rezervedTimeForDate.find(function(t) {
                return t.hour === hour + offset && !t.isOffset;
            });
            var ref;
            return (ref = previousReservedHour === null || previousReservedHour === void 0 ? void 0 : previousReservedHour.harborId) !== null && ref !== void 0 ? ref : null;
        }
        return null;
    };
    var isSomeDateInterceptsWithReservedDates = function(date, duration) {
        var selectedHarbors = {
            start: null,
            end: null
        };
        selectedHarbors.start = checkInterception(date, true);
        var endDate = DateService/* dateService.getEndDateFromHourDuration */.o.getEndDateFromHourDuration(date, duration).toDate();
        selectedHarbors.end = checkInterception(endDate, false);
        if (selectedHarbors.start && selectedHarbors.end) {
            dispatch({
                type: "harbor",
                payload: selectedHarbors.start
            });
            dispatch({
                type: "endHarbor",
                payload: selectedHarbors.end
            });
            setLockHarborsOtherThanThis(selectedHarbors.start);
            return;
        }
        if (selectedHarbors.start) {
            dispatch({
                type: "harbor",
                payload: selectedHarbors.start
            });
            dispatch({
                type: "endHarbor",
                payload: selectedHarbors.start
            });
            setLockHarborsOtherThanThis(selectedHarbors.start);
            return;
        }
        if (selectedHarbors.end) {
            dispatch({
                type: "harbor",
                payload: selectedHarbors.end
            });
            dispatch({
                type: "endHarbor",
                payload: selectedHarbors.end
            });
            setLockHarborsOtherThanThis(selectedHarbors.end);
            return;
        }
        dispatch({
            type: "endHarbor",
            payload: state.harbor
        });
        setLockHarborsOtherThanThis(null);
    };
    (0,react.useEffect)(function() {
        if (state.date) {
            isSomeDateInterceptsWithReservedDates(state.date, state.duration);
        }
    }, [
        state.date,
        state.duration
    ]);
    return {
        lockHarborsOtherThanThis: lockHarborsOtherThanThis
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetPeopleLimits.ts

function usePriceWidgetPeopleLimits(state, diningCapacity, fullCapacity) {
    var MAX_PEOPLE = (0,react.useMemo)(function() {
        return state.selectedMeal ? diningCapacity : fullCapacity;
    }, [
        state.selectedMeal,
        diningCapacity,
        fullCapacity
    ]);
    var MIN_PEOPLE = (0,react.useMemo)(function() {
        return 1;
    }, []);
    return {
        MAX_PEOPLE: MAX_PEOPLE,
        MIN_PEOPLE: MIN_PEOPLE
    };
}

;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetReservedTimes.ts






function usePriceWidgetReservedTimes(state, reservedTimes, rentalInfo) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var generateHourArray = usePriceWidgetHourGenerator().generateHourArray;
    var getIsSpecialDate = usePriceWidgetIsSpecialDate(rentalInfo).getIsSpecialDate;
    var createTourDisabledHours = function(time, dateTimeMapper) {
        var tourStartTime = dayjs(time.dateTimeRange.startTime);
        var tourEndTime = dayjs(time.dateTimeRange.endTime);
        var tourDuration = tourEndTime.diff(tourStartTime, "hour");
        var addDisabledTourHours = function() {
            (0,_to_consumable_array/* default */.Z)(Array(tourDuration)).forEach(function(_, idx) {
                var date = tourStartTime.add(idx, "hour");
                var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date.toDate());
                if (!dateTimeMapper[formattedDate]) {
                    dateTimeMapper[formattedDate] = [];
                }
                var harbor = idx === 0 ? time.startHarbor.id : time.endHarbor.id;
                dateTimeMapper[formattedDate].push({
                    hour: date.hour(),
                    harborId: harbor,
                    isOffset: false
                });
            });
        };
        return {
            harborId: time.startHarbor.id,
            tourStartTime: tourStartTime,
            tourEndTime: tourEndTime,
            tourDuration: tourDuration,
            addDisabledTourHours: addDisabledTourHours
        };
    };
    var mappedReservedTimes = (0,react.useMemo)(function() {
        var dateTimeMapper = {};
        if (state.isSwimmingTour) {
            reservedTimes.forEach(function(time) {
                var swimmingTimes = {
                    start: 10,
                    end: 18
                };
                var ref = createTourDisabledHours(time, dateTimeMapper), tourStartTime = ref.tourStartTime, tourEndTime = ref.tourEndTime, addDisabledTourHours = ref.addDisabledTourHours;
                var startTimeHour = tourStartTime.hour();
                var endTimeHour = tourEndTime.hour();
                if (startTimeHour > swimmingTimes.start && startTimeHour < swimmingTimes.end) {
                    var onlyDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(tourStartTime.toDate());
                    dateTimeMapper[onlyDate] = generateHourArray().map(function(hour) {
                        return {
                            hour: hour
                        };
                    });
                } else if (endTimeHour > swimmingTimes.start && endTimeHour < swimmingTimes.end) {
                    var onlyDate1 = DateService/* dateService.getFormattedDate */.o.getFormattedDate(tourEndTime.toDate());
                    dateTimeMapper[onlyDate1] = generateHourArray().map(function(hour) {
                        return {
                            hour: hour
                        };
                    });
                } else {
                    addDisabledTourHours();
                }
            });
        } else {
            reservedTimes.forEach(function(time) {
                var ref = createTourDisabledHours(time, dateTimeMapper), harborId = ref.harborId, tourStartTime = ref.tourStartTime, addDisabledTourHours = ref.addDisabledTourHours;
                var isSpecialDate = getIsSpecialDate(tourStartTime.toDate());
                var startHourOffset = isSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration;
                var prevOffsetCalculate = startHourOffset - tourStartTime.hour() - 1;
                var isOffsetMoreThanOneDay = prevOffsetCalculate > 0;
                var regularPreviousDateOffset = isOffsetMoreThanOneDay ? prevOffsetCalculate : 0;
                var previousDate = tourStartTime.subtract(1, "day");
                var isPreviousDateSpecialDate = getIsSpecialDate(previousDate.toDate());
                var previosDateHourOffset = isPreviousDateSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration;
                var previousDateHourOffsetFromStartDate = previosDateHourOffset - tourStartTime.hour();
                var isPreviousDateHourOffsetRequiresDateTransition = previosDateHourOffset > startHourOffset && previousDateHourOffsetFromStartDate > 0;
                var previousDayOffset = isPreviousDateHourOffsetRequiresDateTransition ? previousDateHourOffsetFromStartDate : regularPreviousDateOffset;
                var tourDateOffset = startHourOffset - regularPreviousDateOffset - 1;
                var tourDateOffestLen = tourDateOffset >= 0 ? tourDateOffset : 0;
                (0,_to_consumable_array/* default */.Z)(Array(tourDateOffestLen)).forEach(function(_, idx) {
                    var date = tourStartTime.subtract(+idx + 1, "hour");
                    var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date.toDate());
                    if (!dateTimeMapper[formattedDate]) {
                        dateTimeMapper[formattedDate] = [];
                    }
                    var isHourExists = dateTimeMapper[formattedDate].find(function(a) {
                        return a.hour === date.hour();
                    });
                    if (!isHourExists) {
                        dateTimeMapper[formattedDate].push({
                            hour: date.hour(),
                            harborId: harborId,
                            isOffset: true
                        });
                    }
                });
                addDisabledTourHours();
                var previousDateLastHour = 23;
                (0,_to_consumable_array/* default */.Z)(Array(previousDayOffset)).forEach(function(_, idx) {
                    var date = previousDate;
                    var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date.toDate());
                    var dateHour = previousDateLastHour - idx;
                    if (!dateTimeMapper[formattedDate]) {
                        dateTimeMapper[formattedDate] = [];
                    }
                    var isHourExists = dateTimeMapper[formattedDate].find(function(a) {
                        return a.hour === dateHour;
                    });
                    if (!isHourExists) {
                        dateTimeMapper[formattedDate].push({
                            hour: dateHour,
                            harborId: harborId,
                            isOffset: true
                        });
                    }
                });
            });
        }
        Object.entries(dateTimeMapper).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
            var hours = (0,_to_consumable_array/* default */.Z)(new Set(val)).sort(function(a, b) {
                return a.hour - b.hour;
            });
            hours.forEach(function(item) {
                var idx = hours.findIndex(function(v) {
                    return v.hour === item.hour && v.isOffset !== item.isOffset && item.isOffset;
                });
                idx !== -1 && hours.splice(idx, 1);
            });
            dateTimeMapper[key] = hours;
        });
        return dateTimeMapper;
    }, [
        reservedTimes,
        rentalInfo.minimumRentDuration,
        rentalInfo.minimumRentDurationOnSpecialDays,
        state.isSwimmingTour, 
    ]);
    return {
        mappedReservedTimes: mappedReservedTimes
    };
}

// EXTERNAL MODULE: ./src/enums/supportedRentalTypes.ts
var supportedRentalTypes = __webpack_require__(87644);
;// CONCATENATED MODULE: ./src/hooks/priceWidget/usePriceWidgetSwimmingTour.ts






function usePriceWidgetSwimmingTour(state, dispatch, rentalInfo) {
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var doesVehicleSupportOnlySwimmingTour = (0,react.useMemo)(function() {
        return rentalInfo.supportedRentalTypes.every(function(rentalTypes) {
            return rentalTypes === supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR;
        });
    }, [
        rentalInfo.supportedRentalTypes
    ]);
    var doesVehicleNotSupportSwimmingTour = (0,react.useMemo)(function() {
        return rentalInfo.supportedRentalTypes.every(function(rentalTypes) {
            return rentalTypes !== supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR;
        });
    }, [
        rentalInfo.supportedRentalTypes
    ]);
    var generateHourArrayWithoutTen = usePriceWidgetHourGenerator().generateHourArrayWithoutTen;
    var disabledHoursWhenSwimmingTourSelected = (0,react.useMemo)(function() {
        return generateHourArrayWithoutTen().map(function(hour) {
            return {
                hour: hour
            };
        });
    }, []);
    (0,react.useEffect)(function() {
        if (state.isSwimmingTour) {
            var newDate = dayjs(state.date).hour(10).toDate();
            var newDuration = 8;
            dispatch({
                type: "REPLACE_STATE",
                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    date: newDate,
                    duration: newDuration
                })
            });
        }
    }, [
        state.isSwimmingTour
    ]);
    (0,react.useEffect)(function() {
        if (doesVehicleSupportOnlySwimmingTour) {
            dispatch({
                type: "isSwimmingTour",
                payload: true
            });
        }
    }, []);
    return {
        doesVehicleSupportOnlySwimmingTour: doesVehicleSupportOnlySwimmingTour,
        doesVehicleNotSupportSwimmingTour: doesVehicleNotSupportSwimmingTour,
        disabledHoursWhenSwimmingTourSelected: disabledHoursWhenSwimmingTourSelected
    };
}

// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(36333);
// EXTERNAL MODULE: ./src/hooks/useTranslatedNavigation.ts
var useTranslatedNavigation = __webpack_require__(58776);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(25911);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js
var useTranslation = __webpack_require__(56787);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(90935);
// EXTERNAL MODULE: ./src/services/AnalyticsService.ts
var AnalyticsService = __webpack_require__(40515);
// EXTERNAL MODULE: ./src/validation/demand.validation.ts
var demand_validation = __webpack_require__(90119);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetCTAButton.tsx
var PriceWidgetCTAButton = __webpack_require__(4745);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtras.tsx
var PriceWidgetExtras = __webpack_require__(10855);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtrasEmptyView.tsx
var PriceWidgetExtrasEmptyView = __webpack_require__(85382);
// EXTERNAL MODULE: ./src/styles/BSelect.module.css
var BSelect_module = __webpack_require__(6776);
var BSelect_module_default = /*#__PURE__*/__webpack_require__.n(BSelect_module);
// EXTERNAL MODULE: ./src/services/EventBus.ts
var EventBus = __webpack_require__(1210);
// EXTERNAL MODULE: ./src/hooks/useAuthCheck.ts
var useAuthCheck = __webpack_require__(63932);
// EXTERNAL MODULE: ./src/enums/vehiclePriceUnit.ts
var vehiclePriceUnit = __webpack_require__(82871);
// EXTERNAL MODULE: ./src/components/common/BButton.tsx
var BButton = __webpack_require__(87114);
// EXTERNAL MODULE: ./src/components/Form/BTextArea.tsx
var BTextArea = __webpack_require__(49501);
// EXTERNAL MODULE: ./src/components/common/BSpinnerInline.tsx
var BSpinnerInline = __webpack_require__(22773);
// EXTERNAL MODULE: ./src/states/useRemoteConfigState.ts
var useRemoteConfigState = __webpack_require__(18027);
// EXTERNAL MODULE: ./src/utils/getLocalePrefix.ts
var getLocalePrefix = __webpack_require__(14211);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts
var useLocale = __webpack_require__(74021);
// EXTERNAL MODULE: ./node_modules/@phosphor-icons/react/dist/icons/Info.es.js
var Info_es = __webpack_require__(27630);
;// CONCATENATED MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetForm.tsx















































// import equal from 'fast-deep-equal/react';








var PriceWidgetForm = function(param) {
    var supportedServices = param.supportedServices, supportedPackages = param.supportedPackages, supportedMeals = param.supportedMeals, fullCapacity = param.fullCapacity, diningCapacity = param.diningCapacity, vehicleId = param.vehicleId, setPricing = param.setPricing, rentalInfo = param.rentalInfo, reservedTimes = param.reservedTimes, harbors = param.harbors, originHarborId = param.originHarborId, supportedDemandTypes = param.supportedDemandTypes, pricing = param.pricing, isCalculateAmountRequestSent = param.isCalculateAmountRequestSent, setIsCalculateAmountRequestSent = param.setIsCalculateAmountRequestSent, vehicleName = param.vehicleName, vehicleType = param.vehicleType, regionTRName = param.regionTRName, isCalcutePricingRequestOngoing = param.isCalcutePricingRequestOngoing, setIsCalcutePricingRequestOngoing = param.setIsCalcutePricingRequestOngoing, _submitType = param.submitType, submitType = _submitType === void 0 ? "default" : _submitType, _demandId = param.demandId, demandId = _demandId === void 0 ? null : _demandId, submitCallback = param.submitCallback, demandData = param.demandData;
    var ref;
    var dayjs = DateService/* dateService.getDayjs */.o.getDayjs();
    var router = (0,next_router.useRouter)();
    var translateAndNavigate = (0,useTranslatedNavigation/* useTranslatedNavigation */.v)().translateAndNavigate;
    var t = (0,useTranslation/* default */.Z)("vehicle").t;
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var ref1 = (0,useQueryParams/* useQueryParams */.K)(), addQueryParam = ref1.addQueryParam, getQueryParam = ref1.getQueryParam;
    var getIsSpecialDate = usePriceWidgetIsSpecialDate(rentalInfo).getIsSpecialDate;
    var checkLoggedIn = (0,useAuthCheck/* useAuthCheck */.P)().checkLoggedIn;
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var getConfig = (0,useRemoteConfigState/* useRemoteConfigState */.l)().getConfig;
    var isMessagingActive = getConfig("MESSAGING_ENABLED", true);
    var ref3 = (0,react.useState)(false), isDemandRequestOngoing = ref3[0], setIsDemandRequestOngoing = ref3[1];
    var validateForm = function(state, showError) {
        return (0,demand_validation/* vehicleBasedValidation */.Q)(state, MIN_DURATION, MAX_DURATION, fullCapacity, diningCapacity, t, showError);
    };
    var debouncedHandleCalculateAmounts = usePriceWidgetCalculateAmounts(vehicleId, supportedServices, supportedPackages, setPricing, supportedDemandTypes, validateForm, setIsCalculateAmountRequestSent, setIsCalcutePricingRequestOngoing, pricing).debouncedHandleCalculateAmounts;
    var generateSelectedExtraUnits = function(supportedExtras) {
        return supportedExtras.reduce(function(acc, item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, item.id, null));
        }, {});
    };
    var getDefaultState = (0,react.useCallback)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var demandState = {
            date: demandData === null || demandData === void 0 ? void 0 : demandData.startTime,
            duration: (demandData === null || demandData === void 0 ? void 0 : demandData.startTime) && (demandData === null || demandData === void 0 ? void 0 : demandData.endTime) ? DateService/* dateService.getHourDuration */.o.getHourDuration(new Date(demandData.startTime), new Date(demandData.endTime)) : null,
            harbor: "" + ((ref = harbors.find(function(h) {
                return h.label === (demandData === null || demandData === void 0 ? void 0 : demandData.startHarbor);
            })) === null || ref === void 0 ? void 0 : ref.value),
            endHarbor: "" + ((ref1 = harbors.find(function(h) {
                return h.label === (demandData === null || demandData === void 0 ? void 0 : demandData.finishHarbor);
            })) === null || ref1 === void 0 ? void 0 : ref1.value),
            numberOfPeople: (demandData === null || demandData === void 0 ? void 0 : demandData.passengerCount) ? "" + demandData.passengerCount : undefined,
            selectedMeal: demandData === null || demandData === void 0 ? void 0 : (ref2 = demandData.meals) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.id,
            selectedPackage: demandData === null || demandData === void 0 ? void 0 : (ref4 = demandData.packages) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.id,
            selectedServices: demandData === null || demandData === void 0 ? void 0 : demandData.services.map(function(s) {
                return s.id;
            }),
            isSwimmingTour: (demandData === null || demandData === void 0 ? void 0 : demandData.hourlyVariant) === supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR
        };
        var queryParamState = {
            date: getQueryParam("date"),
            duration: demandState.duration || getQueryParam("duration"),
            harbor: demandState.harbor || getQueryParam("harbor"),
            endHarbor: demandState.endHarbor || getQueryParam("endHarbor"),
            numberOfPeople: demandState.numberOfPeople || getQueryParam("numberOfPeople"),
            selectedMeal: demandState.selectedMeal || getQueryParam("selectedMeal"),
            selectedPackage: demandState.selectedPackage || getQueryParam("selectedPackage"),
            selectedServices: demandState.selectedServices || getQueryParam("selectedServices"),
            isSwimmingTour: demandState.isSwimmingTour || getQueryParam("isSwimmingTour"),
            fromLocation: getQueryParam("fromLocation")
        };
        var date = dayjs((demandData === null || demandData === void 0 ? void 0 : demandData.startTime) ? demandData.startTime : queryParamState.date ? +queryParamState.date : undefined).minute(0).second(0).millisecond(0).toDate();
        var isDateSpecialDate = getIsSpecialDate(date);
        var minRentalDur = isDateSpecialDate ? rentalInfo.minimumRentDurationOnSpecialDays : rentalInfo.minimumRentDuration;
        var isQueryParamDurationValid = queryParamState.duration && minRentalDur <= +queryParamState.duration;
        var duration = isQueryParamDurationValid ? +queryParamState.duration : minRentalDur;
        var harbor = queryParamState.harbor && !!harbors.find(function(h) {
            return h.value === +queryParamState.harbor;
        }) ? queryParamState.harbor : "".concat(originHarborId);
        var endHarbor = queryParamState.endHarbor && !!harbors.find(function(h) {
            return h.value === +queryParamState.endHarbor;
        }) ? queryParamState.endHarbor : "".concat(originHarborId);
        if (queryParamState.fromLocation) {
            var fromHarbor = harbors.find(function(h) {
                return h.label === queryParamState.fromLocation;
            });
            if (fromHarbor) {
                harbor = "".concat(fromHarbor.value);
                endHarbor = "".concat(fromHarbor.value);
            }
        }
        var selectedMeal = queryParamState.selectedMeal && !!supportedMeals.find(function(m) {
            return m.id === +queryParamState.selectedMeal;
        }) ? +queryParamState.selectedMeal : null;
        var vehicleCapacity = selectedMeal !== null ? diningCapacity : fullCapacity;
        var numberOfPeople = queryParamState.numberOfPeople && +queryParamState.numberOfPeople > 0 && +queryParamState.numberOfPeople <= vehicleCapacity ? queryParamState.numberOfPeople : "0";
        var selectedPackage = queryParamState.selectedPackage && !!supportedPackages.find(function(m) {
            return m.id === +queryParamState.selectedPackage;
        }) ? +queryParamState.selectedPackage : null;
        var selectedServices = [];
        if (queryParamState.selectedServices && queryParamState.selectedServices.length > 0) {
            queryParamState.selectedServices.forEach(function(s) {
                if (supportedServices.find(function(ss) {
                    return ss.id === +s;
                })) {
                    selectedServices.push(+s);
                }
            });
        }
        return {
            date: date,
            duration: duration,
            harbor: harbor,
            endHarbor: endHarbor,
            numberOfPeople: numberOfPeople,
            selectedMeal: selectedMeal,
            selectedPackage: selectedPackage,
            selectedServices: selectedServices,
            selectedMealsUnits: {},
            selectedPackagesUnits: generateSelectedExtraUnits(supportedPackages),
            selectedServicesUnits: generateSelectedExtraUnits(supportedServices),
            isSwimmingTour: queryParamState.isSwimmingTour === "true" && rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR)
        };
    }, []);
    var dispatchInterceptor = function(state) {
        var ref;
        debouncedHandleCalculateAmounts(state);
        // setStoredState(state);
        var strippedState = {
            date: (ref = state.date) === null || ref === void 0 ? void 0 : ref.getTime(),
            duration: state.duration,
            harbor: state.harbor,
            endHarbor: state.endHarbor,
            numberOfPeople: state.numberOfPeople,
            selectedMeal: state.selectedMeal,
            selectedPackage: state.selectedPackage,
            selectedServices: state.selectedServices,
            isSwimmingTour: state.isSwimmingTour
        };
        submitType !== "message-update" && addQueryParam(strippedState);
    };
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useForm/* useForm */.c)((0,_object_spread/* default */.Z)({}, getDefaultState()), dispatchInterceptor), 2), state = ref4[0], dispatch = ref4[1];
    // useEffect(() => {
    //   if (storedState !== null && !equal(storedState, state)) {
    //     dispatch({
    //       payload: storedState,
    //       type: 'REPLACE_STATE',
    //     });
    //   }
    // }, [storedState, state]);
    var ref5 = usePriceWidgetSwimmingTour(state, dispatch, rentalInfo), disabledHoursWhenSwimmingTourSelected = ref5.disabledHoursWhenSwimmingTourSelected, doesVehicleNotSupportSwimmingTour = ref5.doesVehicleNotSupportSwimmingTour, doesVehicleSupportOnlySwimmingTour = ref5.doesVehicleSupportOnlySwimmingTour;
    var mappedReservedTimes = usePriceWidgetReservedTimes(state, reservedTimes, rentalInfo).mappedReservedTimes;
    var datePickerDisabledHours = usePriceWidgetDisabledHours(state, supportedDemandTypes, rentalInfo).datePickerDisabledHours;
    var isDateAvailable = usePriceWidgetClosestAvailability(state, dispatch, mappedReservedTimes, datePickerDisabledHours, demandData).isDateAvailable;
    var lockHarborsOtherThanThis = usePriceWidgetHarborIntersections(state, dispatch, mappedReservedTimes).lockHarborsOtherThanThis;
    var ref6 = usePriceWidgetPeopleLimits(state, diningCapacity, fullCapacity), MAX_PEOPLE = ref6.MAX_PEOPLE, MIN_PEOPLE = ref6.MIN_PEOPLE;
    var ref7 = usePriceWidgetDurationLimits(state, dispatch, rentalInfo, mappedReservedTimes, datePickerDisabledHours, demandData), MAX_DURATION = ref7.MAX_DURATION, MIN_DURATION = ref7.MIN_DURATION;
    var extraTabs = (0,usePriceWidgetExtraSections/* usePriceWidgetExtraSections */.K)(state, dispatch, supportedMeals, supportedPackages, supportedServices, diningCapacity).extraTabs;
    var clearUnsupportedExtras = function() {
        var statePackage = state["selectedPackage"];
        var stateServices = state["selectedServices"];
        var stateMeal = state["selectedMeal"];
        var selectedPackage = supportedPackages.some(function(p) {
            return p.id === statePackage;
        }) ? statePackage : null;
        var selectedServices = stateServices.filter(function(service) {
            return supportedServices.some(function(supportedService) {
                return supportedService.id === service;
            });
        });
        var selectedMeal = supportedMeals.some(function(m) {
            return m.id === stateMeal;
        }) ? stateMeal : null;
        return {
            selectedPackage: selectedPackage,
            selectedServices: selectedServices,
            selectedMeal: selectedMeal
        };
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var clearedExtras, filteredState, isValid, payload, ref, ref1, ref2, ref3, res, ref4, ref5, ref6, ref7, ref8, ref9, ref10, res1, ref11, ref12, ref13;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        if (state.date && !isDateAvailable(state.date)) {
                            react_toastify_esm/* toast.error */.Am.error(t("priceWidget.form.errors.dateNotValid"), {
                                toastId: "noValidDate"
                            });
                            return [
                                2,
                                false
                            ];
                        }
                        clearedExtras = clearUnsupportedExtras();
                        filteredState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            selectedPackage: clearedExtras.selectedPackage,
                            selectedServices: clearedExtras.selectedServices,
                            selectedMeal: clearedExtras.selectedMeal
                        });
                        return [
                            4,
                            validateForm(filteredState, true)
                        ];
                    case 1:
                        isValid = _state.sent();
                        if (!isValid) return [
                            2,
                            false
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            ,
                            9,
                            10
                        ]);
                        setIsDemandRequestOngoing(true);
                        payload = DemandService/* demandService.formatVehicleBasedDemandStateToDemand */.l.formatVehicleBasedDemandStateToDemand(filteredState, vehicleId, (0,_to_consumable_array/* default */.Z)(supportedServices).concat((0,_to_consumable_array/* default */.Z)(supportedPackages)), pricing);
                        if (!(submitType === "default")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            DemandService/* demandService.createDemand */.l.createDemand((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "API"
                            }))
                        ];
                    case 3:
                        res = _state.sent();
                        AnalyticsService/* analyticsService.addToCartVehicleBased */.I.addToCartVehicleBased({
                            vehicleId: vehicleId,
                            totalPrice: (ref4 = (ref = payload.paymentInfo) === null || ref === void 0 ? void 0 : ref.totalAmount) !== null && ref4 !== void 0 ? ref4 : 0,
                            currency: (ref5 = (ref1 = payload.paymentInfo) === null || ref1 === void 0 ? void 0 : ref1.currency) !== null && ref5 !== void 0 ? ref5 : currency/* Currency.TRY */.F.TRY,
                            duration: filteredState.duration,
                            hourlyPrice: (ref6 = (ref2 = payload.paymentInfo) === null || ref2 === void 0 ? void 0 : ref2.vehicleCostPerUnit) !== null && ref6 !== void 0 ? ref6 : 0,
                            region: regionTRName,
                            vehicleName: vehicleName,
                            vehiclePriceUnit: filteredState.isSwimmingTour ? "SWIMMING_TOUR" : ((ref3 = payload.paymentInfo) === null || ref3 === void 0 ? void 0 : ref3.priceUnit) || vehiclePriceUnit/* VehiclePriceUnit.HOUR */.k.HOUR,
                            vehicleType: vehicleType
                        });
                        if (res.offerId) {
                            window.open("".concat((0,getLocalePrefix/* getLocalePrefix */.A)(locale), "payment/").concat(res.offerId), "_self");
                        } else {
                            react_toastify_esm/* toast.success */.Am.success(t("priceWidget.demandSuccess"), {
                                toastId: "demandSuccess"
                            });
                            if (isMessagingActive && vehicleType === vehicleTypes/* VehicleType.INVITATION_BOAT */.F.INVITATION_BOAT) {
                                translateAndNavigate("/message?demandId=".concat(res.demandId));
                            } else {
                                translateAndNavigate("/tekliflerim");
                            }
                        }
                        return [
                            3,
                            8
                        ];
                    case 4:
                        if (!(submitType === "message")) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            DemandService/* demandService.createDemand */.l.createDemand((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                initialMessage: message,
                                source: "MESSAGE"
                            }), {
                                hideError: false
                            }).catch()
                        ];
                    case 5:
                        res1 = _state.sent();
                        AnalyticsService/* analyticsService.addToCartVehicleBased */.I.addToCartVehicleBased({
                            vehicleId: vehicleId,
                            totalPrice: (ref11 = (ref7 = payload.paymentInfo) === null || ref7 === void 0 ? void 0 : ref7.totalAmount) !== null && ref11 !== void 0 ? ref11 : 0,
                            currency: (ref12 = (ref8 = payload.paymentInfo) === null || ref8 === void 0 ? void 0 : ref8.currency) !== null && ref12 !== void 0 ? ref12 : currency/* Currency.TRY */.F.TRY,
                            duration: filteredState.duration,
                            hourlyPrice: (ref13 = (ref9 = payload.paymentInfo) === null || ref9 === void 0 ? void 0 : ref9.vehicleCostPerUnit) !== null && ref13 !== void 0 ? ref13 : 0,
                            region: regionTRName,
                            vehicleName: vehicleName,
                            vehiclePriceUnit: filteredState.isSwimmingTour ? "SWIMMING_TOUR" : ((ref10 = payload.paymentInfo) === null || ref10 === void 0 ? void 0 : ref10.priceUnit) || vehiclePriceUnit/* VehiclePriceUnit.HOUR */.k.HOUR,
                            vehicleType: vehicleType
                        });
                        router.push("/message?demandId=".concat(res1.demandId));
                        return [
                            3,
                            8
                        ];
                    case 6:
                        if (!(submitType === "message-update" && demandId)) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            DemandService/* demandService.updateDemand */.l.updateDemand(demandId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                                source: "MESSAGE"
                            }))
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        submitCallback === null || submitCallback === void 0 ? void 0 : submitCallback();
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsDemandRequestOngoing(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var updateSwimmingTour = function() {
            dispatch({
                payload: true,
                type: "isSwimmingTour"
            });
        };
        EventBus/* eventBus.addEventListener */.Y.addEventListener(EventBus/* eventBus.events.SWIMMING_TOUR_CHANGE */.Y.events.SWIMMING_TOUR_CHANGE, updateSwimmingTour);
        return function() {
            EventBus/* eventBus.removeEventListener */.Y.removeEventListener(EventBus/* eventBus.events.SWIMMING_TOUR_CHANGE */.Y.events.SWIMMING_TOUR_CHANGE, updateSwimmingTour);
        };
    }, []);
    var endHourOnNextDay = function() {
        var isImmediateReservation = supportedDemandTypes.includes(SupportedDemandType/* SupportedDemandType.IMMEDIATE_RESERVATION */.g.IMMEDIATE_RESERVATION);
        if (isImmediateReservation) {
            var ref, ref1, ref2;
            if (((ref = rentalInfo.operationalHours) === null || ref === void 0 ? void 0 : ref.start) === ((ref1 = rentalInfo.operationalHours) === null || ref1 === void 0 ? void 0 : ref1.end)) {
                return 6;
            }
            if ((((ref2 = rentalInfo.operationalHours) === null || ref2 === void 0 ? void 0 : ref2.end) || 6) >= 6) {
                return 6;
            } else {
                var ref3;
                return (((ref3 = rentalInfo.operationalHours) === null || ref3 === void 0 ? void 0 : ref3.end) || 0) + 1;
            }
        } else {
            return 6;
        }
    }();
    var formItemClasses = "pb-2.5 pt-1 px-3";
    var formLabelClasses = "text-sm font-semibold mb-1 inline-block";
    var formBorderColor = "border-slate-500";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            rentalInfo.supportedRentalTypes.includes(supportedRentalTypes/* SupportedHourlyRentalTypes.SWIMMING_TOUR */.a.SWIMMING_TOUR) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 mt-1 text-sm text-slate-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Info_es/* default */.Z, {
                        size: 14,
                        className: "mr-1 mb-1 inline-block"
                    }),
                    "Bu tekne ile",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold text-primary-500",
                        children: "y\xfczme turu"
                    }),
                    " ",
                    "yapabilirsiniz.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold",
                        children: "Tarih se\xe7erken y\xfczme turu se\xe7eneğini işaretlemeyi"
                    }),
                    " ",
                    "unutmayınız."
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("form mt-3 grid grid-cols-2 rounded-2xl border", formBorderColor),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(formItemClasses, formBorderColor, "border-b border-r"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: formLabelClasses,
                                htmlFor: "harbor",
                                children: t("priceWidget.form.harbor")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                id: "harbor",
                                className: classnames_default()("naked-input block w-full text-center", (BSelect_module_default())["b-select"]),
                                placeholder: "limansec",
                                value: state.harbor,
                                onChange: function(event) {
                                    dispatch({
                                        type: "harbor",
                                        payload: event.target.value
                                    });
                                    dispatch({
                                        type: "endHarbor",
                                        payload: event.target.value
                                    });
                                },
                                children: harbors.map(function(harbor) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: harbor.value,
                                        disabled: !!lockHarborsOtherThanThis && lockHarborsOtherThanThis !== harbor.value,
                                        children: harbor.label
                                    }, harbor.value);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(formItemClasses, formBorderColor, "border-b"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: formLabelClasses,
                                htmlFor: "datepicker",
                                children: t("priceWidget.form.date")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BDatePicker/* default */.Z, {
                                minDetail: "year",
                                next2Label: null,
                                prev2Label: null,
                                calendarClasses: "!top-8 -right-3",
                                disabledDates: mappedReservedTimes,
                                inputClasses: "text-center naked-input",
                                minDate: new Date(),
                                disabledHours: state.isSwimmingTour ? disabledHoursWhenSwimmingTourSelected : datePickerDisabledHours,
                                showOnLeft: true,
                                showTimePicker: true,
                                endHourOnNextDay: endHourOnNextDay,
                                value: state.date,
                                onChange: function(val) {
                                    return dispatch({
                                        type: "date",
                                        payload: val
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "px-2 pt-1 pb-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BSwitch/* default */.Z, {
                                            value: state.isSwimmingTour,
                                            disabled: doesVehicleSupportOnlySwimmingTour || doesVehicleNotSupportSwimmingTour,
                                            labelClasses: "text-info-600",
                                            onChange: function(val) {
                                                return dispatch({
                                                    type: "isSwimmingTour",
                                                    payload: val
                                                });
                                            },
                                            label: t("priceWidget.form.swimmingTour")
                                        }),
                                        doesVehicleSupportOnlySwimmingTour || doesVehicleNotSupportSwimmingTour ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mt-1 inline-block text-sm text-slate-500",
                                            children: doesVehicleSupportOnlySwimmingTour ? t("priceWidget.form.swimmingTourOnlySupported") : t("priceWidget.form.swimmingTourNotSupported")
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()(formItemClasses, formBorderColor, "border-r"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: formLabelClasses,
                                htmlFor: "duration",
                                children: t("priceWidget.form.duration")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BStepperInput/* default */.Z, {
                                inputProps: {
                                    id: "duration"
                                },
                                minLimit: MIN_DURATION,
                                maxLimit: MAX_DURATION,
                                suffix: t("priceWidget.form.HOUR"),
                                value: state.duration,
                                onChange: function(value) {
                                    return dispatch({
                                        type: "duration",
                                        payload: value
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: formItemClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: formLabelClasses,
                                htmlFor: "number-of-people",
                                children: t("priceWidget.form.personCount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BStepperInput/* default */.Z, {
                                    inputProps: {
                                        id: "number-of-people"
                                    },
                                    minLimit: MIN_PEOPLE,
                                    maxLimit: MAX_PEOPLE,
                                    value: state.numberOfPeople,
                                    inputEnabled: true,
                                    boundaryErrorKey: "vehicle:priceWidget.form.personCountBoundaryError",
                                    onChange: function(value) {
                                        return dispatch({
                                            type: "numberOfPeople",
                                            payload: value
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithActivator/* default */.Z, {
                modalTitle: t("priceWidget.form.extrasModal.title"),
                activator: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtras/* default */.Z, {}),
                modalClass: "h-screen",
                children: extraTabs.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BTabs/* default */.Z, {
                    tabs: extraTabs
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtrasEmptyView/* default */.Z, {})
            }),
            state.isSwimmingTour ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BAlert/* default */.Z, {
                variant: "info",
                className: "mt-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "vehicle:priceWidget.form.alerts.swimmingTour"
                })
            }) : null,
            submitType === "default" && lockHarborsOtherThanThis && harbors.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BAlert/* default */.Z, {
                variant: "secondary",
                className: "mt-4",
                children: state.harbor !== state.endHarbor ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                    i18nKey: "vehicle:priceWidget.form.alerts.endHarborChangedDueRezervations",
                    values: {
                        harbor: (ref = harbors.find(function(h) {
                            return +state.endHarbor === h.value;
                        })) === null || ref === void 0 ? void 0 : ref.label
                    },
                    components: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "text-primary-700"
                        }, "harborEmphasis"), 
                    ]
                }) : t("priceWidget.form.alerts.harborsDisabledDueReservation")
            }) : null,
            submitType === "message" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BTextArea/* default */.Z, {
                value: message,
                onChange: function(e) {
                    return setMessage(e.target.value);
                },
                className: "mt-4"
            }) : null,
            submitType === "default" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetCTAButton/* default */.Z, {
                className: "mt-4",
                fluid: true,
                onClick: onSubmit,
                supportedDemandTypes: supportedDemandTypes,
                pricing: pricing,
                isCalculateAmountRequestSent: isCalculateAmountRequestSent,
                isCalcutePricingRequestOngoing: isCalcutePricingRequestOngoing,
                isDemandRequestOngoing: isDemandRequestOngoing
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                className: "mt-4",
                fluid: true,
                onClick: onSubmit,
                disabled: isDemandRequestOngoing,
                children: isDemandRequestOngoing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSpinnerInline/* default */.Z, {
                    size: 24,
                    className: "mx-auto"
                }) : submitType === "message" ? t("message.cta") : t("update.cta")
            })
        ]
    });
};
/* harmony default export */ var PriceWidget_PriceWidgetForm = (PriceWidgetForm);


/***/ }),

/***/ 52940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59354);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _formkit_auto_animate_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57394);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32466);
/* harmony import */ var _BButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87114);






var BTabs = function(param) {
    var bodyClasses = param.bodyClasses, tabClasses = param.tabClasses, wrapperClasses = param.wrapperClasses, tabsWrapperClasses = param.tabsWrapperClasses, tabs = param.tabs;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), activeTabIndex = ref[0], setActiveTabIndex = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_formkit_auto_animate_react__WEBPACK_IMPORTED_MODULE_1__/* .useAutoAnimate */ .u)(), 1), parent = ref1[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("b-tabs", wrapperClasses),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(tabsWrapperClasses, "border-b border-primary-900"),
                children: tabs.map(function(tab, idx) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        priority: activeTabIndex === idx ? "contained" : "text",
                        variant: activeTabIndex === idx ? "primary" : "secondary",
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("b-tab", "rounded-b-none !px-5 !py-2 shadow-none"),
                        onClick: function() {
                            return setActiveTabIndex(idx);
                        },
                        children: tab.title
                    }, "tab-".concat(idx));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: parent,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(bodyClasses, "mt-4"),
                children: tabs.map(function(tab, idx) {
                    return idx === activeTabIndex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(tabClasses),
                        children: tab.children
                    }, "tab-child-".concat(idx)) : null;
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BTabs);


/***/ }),

/***/ 7794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SupportedDemandType; }
/* harmony export */ });
var SupportedDemandType;
(function(SupportedDemandType) {
    SupportedDemandType[/**
   * No Targeted Vehicle
   */ "TENDER"] = "TENDER";
    SupportedDemandType[/**
   * Targeted Vehicle has neither pricing information nor calendar information
   */ "VEHICLE_TARGETED"] = "VEHICLE_TARGETED";
    SupportedDemandType[/**
   * Targeted Vehicle has pricing information but lacks of calendar information
   */ "AVAILABILITY"] = "AVAILABILITY";
    SupportedDemandType[/**
   * Targeted Vehicle has calendar information but lacks of pricing information
   */ "PRICE"] = "PRICE";
    SupportedDemandType[/**
   * Targeted Vehicle has both of calendar and pricing information but disabled immediate reservation feature
   */ "RESERVATION"] = "RESERVATION";
    SupportedDemandType[/**
   * Target vehicle has both of calendar and pricing information and enabled immediate reservation feature
   */ "IMMEDIATE_RESERVATION"] = "IMMEDIATE_RESERVATION";
})(SupportedDemandType || (SupportedDemandType = {}));


/***/ }),

/***/ 188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useCheckPricingExists; }
/* harmony export */ });
/* harmony import */ var enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);

function useCheckPricingExists(supportedDemandTypes) {
    var checkPricingExists = function() {
        return supportedDemandTypes.some(function(item) {
            return item === enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDemandType.AVAILABILITY */ .g.AVAILABILITY || item === enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDemandType.IMMEDIATE_RESERVATION */ .g.IMMEDIATE_RESERVATION || item === enums_SupportedDemandType__WEBPACK_IMPORTED_MODULE_0__/* .SupportedDemandType.RESERVATION */ .g.RESERVATION;
        });
    };
    return {
        checkPricingExists: checkPricingExists
    };
}


/***/ }),

/***/ 21052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ usePriceWidgetExtraSections; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80072);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18098);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36840);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var components_Vehicle_VehicleDetail_PriceWidget_PriceWidgetExtraSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50169);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56787);







function usePriceWidgetExtraSections(state, dispatch, supportedMeals, supportedPackages, supportedServices, diningCapacity) {
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("vehicle").t;
    var extrasSections = [];
    supportedMeals.length && extrasSections.push({
        stateBaseKey: "selectedMeal",
        stateUnitKey: "selectedMealsUnits",
        title: "mealsTitle",
        description: +state.numberOfPeople > diningCapacity ? "mealsDescriptionNumberOfPeople" : "mealsDescription",
        disabled: +state.numberOfPeople > diningCapacity,
        list: supportedMeals,
        isValueSingular: true
    });
    supportedPackages.length && extrasSections.push({
        stateBaseKey: "selectedPackage",
        stateUnitKey: "selectedPackagesUnits",
        title: "packagesTitle",
        description: "packagesDescription",
        showDescriptionWhen: true,
        list: supportedPackages,
        isValueSingular: true
    });
    supportedServices.length && extrasSections.push({
        stateBaseKey: "selectedServices",
        stateUnitKey: "selectedServicesUnits",
        title: "servicesTitle",
        list: supportedServices,
        isValueSingular: false
    });
    var getExtraTabsChildren = function(section) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Vehicle_VehicleDetail_PriceWidget_PriceWidgetExtraSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            getChecked: function(val) {
                return section.isValueSingular ? // @ts-expect-error gunluk haftalik typelariyla cok cakisiyor
                state[section.stateBaseKey] === val : // @ts-expect-error gunluk haftalik typelariyla cok cakisiyor
                state[section.stateBaseKey].includes(val);
            },
            list: section.list,
            description: section.description && t("priceWidget.form.extrasModal.".concat(section.description)),
            disabled: section.disabled,
            onChange: function(isChecked, value) {
                if (section.isValueSingular) {
                    dispatch({
                        type: section.stateBaseKey,
                        payload: isChecked ? value : null
                    });
                } else {
                    dispatch({
                        type: section.stateBaseKey,
                        payload: value,
                        isAppend: isChecked
                    });
                }
            },
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error gunluk haftalik typelariyla cok cakisiyor
            getUnits: function(id) {
                return state[section.stateUnitKey][id] || "";
            },
            onUnitChange: function(id, value) {
                dispatch({
                    type: section.stateUnitKey,
                    payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state[section.stateUnitKey]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, id, value))
                });
            }
        }, section.stateBaseKey);
    };
    var extraTabs = extrasSections.reduce(function(acc, section) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(acc).concat([
            {
                title: t("priceWidget.form.extrasModal.".concat(section.title)),
                children: getExtraTabsChildren(section)
            }, 
        ]);
    }, []);
    return {
        extrasSections: extrasSections,
        getExtraTabsChildren: getExtraTabsChildren,
        extraTabs: extraTabs
    };
}


/***/ }),

/***/ 63932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useAuthCheck; }
/* harmony export */ });
/* harmony import */ var enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85561);
/* harmony import */ var states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31087);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13253);



function useAuthCheck() {
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_2__/* .useUserState */ .e)().isUserLoggedIn;
    var ref = (0,states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__/* .useAuthModalState */ .d)(), setAuthMode = ref.setAuthMode, setShowAuthModal = ref.setShowAuthModal;
    var checkLoggedIn = function() {
        if (!isUserLoggedIn) {
            setAuthMode(enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__/* .AuthModalMode.LOGIN */ .g.LOGIN);
            setShowAuthModal(true);
        }
        return isUserLoggedIn;
    };
    return {
        checkLoggedIn: checkLoggedIn
    };
}


/***/ }),

/***/ 58776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useTranslatedNavigation; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var services_LocalizationService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55389);



var useTranslatedNavigation = function() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(), locale = ref.locale, push = ref.push;
    var translateAndNavigate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(href) {
        var as = services_LocalizationService__WEBPACK_IMPORTED_MODULE_2__/* .localizationService.translatePathname */ .R.translatePathname(href, locale);
        var pathname = as !== null && as !== void 0 ? as : href;
        push(pathname, as, {
            locale: locale
        });
    }, [
        locale,
        push
    ]);
    return {
        translateAndNavigate: translateAndNavigate
    };
};


/***/ }),

/***/ 90119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ vehicleBasedValidation; },
/* harmony export */   "W": function() { return /* binding */ vehicleBasedDWValidation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6814);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50132);
/* harmony import */ var enums_businessModel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60287);
/* harmony import */ var enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87644);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90935);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21565);








var vehicleBasedValidationSchemaFactory = function(param) {
    var minDuration = param.minDuration, maxDuration = param.maxDuration, capacity = param.capacity, variant = param.variant;
    var now = new Date();
    var duration = (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .number */ .Rx)().required("vehicle:priceWidget.form.errors.durationRequired").min(minDuration, "vehicle:priceWidget.form.errors.durationMin");
    return (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .object */ .Ry)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        harbor: (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .number */ .Rx)().required("vehicle:priceWidget.form.errors.harborRequired"),
        numberOfPeople: (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .number */ .Rx)().required("vehicle:priceWidget.form.errors.numberOfPeopleRequired").min(1, "vehicle:priceWidget.form.errors.numberOfPeopleMin").max(capacity, "vehicle:priceWidget.form.errors.numberOfPeopleMax")
    }, variant === enums_businessModel__WEBPACK_IMPORTED_MODULE_0__/* .BusinessModel.HOURLY */ .v.HOURLY ? {
        date: (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT)().required("vehicle:priceWidget.form.errors.dateRequired"),
        duration: !maxDuration ? duration : duration.max(maxDuration, "vehicle:priceWidget.form.errors.durationMax")
    } : {
        startDate: (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT)().required("vehicle:priceWidget.form.errors.dateRequired").min(now, "vehicle:priceWidget.form.errors.dateMin").max((0,yup__WEBPACK_IMPORTED_MODULE_3__/* .ref */ .iH)("endDate"), "vehicle:priceWidget.form.errors.startDateMax").notOneOf([
            (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .ref */ .iH)("endDate")
        ]),
        endDate: (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .date */ .hT)().required("vehicle:priceWidget.form.errors.dateRequired").min((0,yup__WEBPACK_IMPORTED_MODULE_3__/* .ref */ .iH)("startDate"), "vehicle:priceWidget.form.errors.endDateMin").notOneOf([
            (0,yup__WEBPACK_IMPORTED_MODULE_3__/* .ref */ .iH)("startDate")
        ])
    }));
};
var vehicleBasedValidation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(state, minDuration, maxDuration, fullCapacity, diningCapacity, t) {
        var showError, capacity, validationSchema, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    showError = _arguments.length > 6 && _arguments[6] !== void 0 ? _arguments[6] : false;
                    capacity = state.selectedMeal !== null ? diningCapacity : fullCapacity;
                    validationSchema = vehicleBasedValidationSchemaFactory({
                        minDuration: minDuration,
                        maxDuration: maxDuration,
                        capacity: capacity,
                        variant: enums_businessModel__WEBPACK_IMPORTED_MODULE_0__/* .BusinessModel.HOURLY */ .v.HOURLY
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        validationSchema.validate(state, {
                            abortEarly: false
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    error = _state.sent();
                    if (showError && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(error, yup__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError */ .p8)) {
                        error.inner.forEach(function(e) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(t(e.message), {
                                toastId: "demandError-".concat(e.name)
                            });
                        });
                    }
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function vehicleBasedValidation(state, minDuration, maxDuration, fullCapacity, diningCapacity, t) {
        return _ref.apply(this, arguments);
    };
}();
var vehicleBasedDWValidation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(state, minDuration, cruisingCapacity, overnightCapacity, t) {
        var showError, ref, ref1, capacity, validationSchema, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    showError = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : false;
                    capacity = state.demandVariant === enums_supportedRentalTypes__WEBPACK_IMPORTED_MODULE_1__/* .SupportedDailyWeeklyRentalTypes.HALF_DAY */ .N.HALF_DAY ? cruisingCapacity : overnightCapacity;
                    validationSchema = vehicleBasedValidationSchemaFactory({
                        minDuration: minDuration,
                        capacity: capacity,
                        variant: enums_businessModel__WEBPACK_IMPORTED_MODULE_0__/* .BusinessModel.DAILY_WEEKLY */ .v.DAILY_WEEKLY
                    });
                    if (((ref = state.startDate) === null || ref === void 0 ? void 0 : ref.getTime()) === ((ref1 = state.endDate) === null || ref1 === void 0 ? void 0 : ref1.getTime())) {
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        validationSchema.validate(state, {
                            abortEarly: false
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    error = _state.sent();
                    if (showError && (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(error, yup__WEBPACK_IMPORTED_MODULE_3__/* .ValidationError */ .p8)) {
                        error.inner.forEach(function(e) {
                            react_toastify__WEBPACK_IMPORTED_MODULE_2__/* .toast.error */ .Am.error(t(e.message), {
                                toastId: "demandError-".concat(e.name)
                            });
                        });
                    }
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function vehicleBasedDWValidation(state, minDuration, cruisingCapacity, overnightCapacity, t) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"b-select":"BSelect_b-select__MgxBw"};

/***/ })

}]);